import { useCallback } from "react";

const translations = {
    fr: {
        dashboard: 'Tableau de bord',
        management: 'Gestion',
        finance: 'Finance',
        support: 'Support',
        authentication: 'Authentification',
        settings: 'Paramètres',
        users: 'Utilisateurs',
        suppliers: 'Fournisseurs',
        exchangeRate: 'Taux de change',
        sales: 'État des ventes',
        reservations: 'Réservations',
        products: 'Produits',
        promotions: 'Promotions',
        statistics: 'Statistiques',
        adminSupport: 'Support Admin',
        supplierSupport: 'Support Fournisseur',
        welcome: 'Bienvenue',
        overview: 'Vue d\'ensemble',
        logout: 'Déconnexion',
        profile: 'Profil',
        revenue: 'Revenus',
        newUsers: 'Nouveaux utilisateurs',
        activeSuppliers: 'Fournisseurs actifs',
        productsInStock: 'Produits en stock',
        todaysRevenue: 'Revenus du jour',
        monthlyRevenue: 'Revenus du mois',
        unpaidInvoices: 'Factures impayées',
        conversionRate: 'Taux de conversion',
        thisWeek: 'Cette semaine',
        total: 'Total',
        available: 'Disponibles',
        thisMonth: 'Ce mois',
        recentActivity: 'Activité récente',
        supportTickets: 'Tickets support',
        createdProduct: 'a créé un nouveau produit',
        madeReservation: 'a effectué une réservation',
        updatedPromotion: 'a mis à jour une promotion',
        addedSupplier: 'a ajouté un fournisseur',
        pricing: 'Tarification',
        supplier: 'Fournisseur',
        generatedInvoice: 'a généré une facture',
        paymentIssue: 'Problème de paiement',
        productQuestion: 'Question sur produit',
        refundRequest: 'Demande de remboursement',
        adminInterfaceBug: 'Bug interface admin',
        urgent: 'Urgent',
        pending: 'En attente',
        resolved: 'Résolu',
        high: 'Élevée',
        low: 'Basse',
        globalStatistics: 'Statistiques Globales',
        salesEvolution: 'Évolution des ventes',
        id: 'ID',
        subject: 'Sujet',
        status: 'Statut',
        priority: 'Priorité',
        time: 'Temps',
        enter: 'Entrer',
        searchSectionPlaceholder: 'Rechercher une section... ',
        main: 'Principal',
        keyMetrics: 'Indicateurs clés',
        totalProducts: 'Produits totaux',
        pendingPayment: 'En attente de paiement',
        supportRequests: 'Demandes de support',
        salesByCountry: 'Ventes par pays',
        other: 'Autres',
        topSellingProducts: 'Produits les plus vendus',
        connectedUsers: 'Utilisateurs connectés',
        online: 'En ligne',
        away: 'Absent',
        trendingSearches: 'Recherches tendances',
        searches: 'recherches',
        agenda: 'Agenda',
        participants: 'participants',
        meeting: 'réunion',
        presentation: 'présentation',
        review: 'revue',
        training: 'formation',
        teamMeeting: 'Réunion d\'équipe',
        clientPresentation: 'Présentation client',
        productReview: 'Revue de produit',
        trainingSession: 'Session de formation',
        deliveryProblem: 'Problème de livraison',
        technicalSupport: 'Support technique',
        openTickets: 'Tickets ouverts',

        // Traductions de connexion
        login: "Connexion",
        forgotPassword: "Mot de passe oublié",
        email: "E-mail",
        password: "Mot de passe",
        rememberMe: "Se souvenir de moi",
        loginButton: "Se connecter",
        noAccount: "Pas encore de compte ?",
        signUp: "S'inscrire",
        forgotPasswordLink: "Mot de passe oublié ?",
        backToLogin: "Retour à la connexion",
        resetPassword: "Réinitialiser le mot de passe",
        sendResetLink: "Envoyer le lien",
        resetEmailSent: "Un email de réinitialisation a été envoyé",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        updatePassword: "Mettre à jour le mot de passe",
        passwordUpdated: "Mot de passe mis à jour avec succès",
        emailPlaceholder: "votre@email.com",
        passwordPlaceholder: "Entrez votre mot de passe",
        emailRequired: "L'email est requis",
        passwordRequired: "Le mot de passe est requis",
        invalidEmail: "Email invalide",
        passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
        passwordsDontMatch: "Les mots de passe ne correspondent pas",
        loginError: "Email ou mot de passe incorrect",
        resetPasswordTitle: "Réinitialiser votre mot de passe",
        resetPasswordDesc: "Entrez votre email pour recevoir un lien de réinitialisation",
        updatePasswordTitle: "Créer un nouveau mot de passe",
        updatePasswordDesc: "Entrez votre nouveau mot de passe",
        passwordUpdateSuccess: "Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",

        // Page Utilisateurs
        usersManagement: "Gestion des Utilisateurs",
        addUser: "Ajouter un utilisateur",

        // Cartes de statistiques
        totalUsers: "Utilisateurs Totaux",
        allPlatformUsers: "Tous les utilisateurs de la plateforme",
        currentlyOnline: "Actuellement en ligne",
        administrators: "Administrateurs",
        usersWithAdminRights: "Utilisateurs avec droits admin",
        otherUsers: "Autres Utilisateurs",
        standardUsers: "Utilisateurs standards",

        // Colonnes du tableau
        name: "Nom",
        role: "Rôle",
        lastLogin: "Dernière connexion",
        department: "Département",
        phone: "Téléphone",

        // Actions et messages
        confirmDeleteUser: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
        editUser: "Modifier l'utilisateur",
        deleteUser: "Supprimer l'utilisateur",
        viewDetails: "Voir les détails",

        // composant tableau 
        searchPlaceholder: "Rechercher...",
        allColumns: "Toutes les colonnes",
        expand: "Développer",
        actions: "Actions",
        noData: "Aucune donnée à afficher",
        edit: "Éditer",
        delete: "Supprimer",
        details: "Détails",

        // Alertes et confirmations
        confirmDeleteTitle: "Confirmer la suppression",
        confirmDeleteText: "Êtes-vous sûr de vouloir supprimer l'utilisateur {{name}} ?",
        deleteConfirm: "Oui, supprimer",
        cancel: "Annuler",
        userDeletedSuccess: "Utilisateur supprimé avec succès",
        userAddedSuccess: "Utilisateur ajouté avec succès",
        userUpdatedSuccess: "Utilisateur modifié avec succès",

        // Formulaire
        leaveBlankPassword: "Laisser vide pour garder l'ancien mot de passe",
        save: "Enregistrer",
        close: "Fermer",

        // Modal utilisateur
        userDetails: "Détails de l'utilisateur",
        enterName: "Entrez le nom",
        enterEmail: "Entrez l'email",
        enterPassword: "Entrez le mot de passe",
        enterDepartment: "Entrez le département",
        confirmPasswordPlaceholder: "Confirmez le mot de passe",
        optional: "optionnel",
        nameRequired: "Le nom est requis",

        // Rôles
        user: "Utilisateur",
        manager: "Manager",
        admin: "Administrateur",

        // Page Réservations
        bookingsManagement: "Gestion des Réservations",
        totalBookings: "Réservations Totales",
        allTimeBookings: "Depuis le début",
        confirmedBookings: "Réservations Confirmées",
        confirmedThisMonth: "Confirmées ce mois",
        totalRevenue: "Revenus totaux",
        cancelledBookings: "Réservations Annulées",
        cancelledThisMonth: "Annulées ce mois",

        // Filtres
        allServices: "Tous les services",
        allStatus: "Tous les statuts",
        confirmed: "Confirmé",
        cancelled: "Annulé",
        cancelled_at: "Annulé le",

        // Colonnes tableau
        bookingNumber: "N° de Réservation",
        service: "Service",
        checkin: "Arrivée",
        checkout: "Départ",
        provider: "Fournisseur",
        totalAmount: "Montant total",
        paymentStatus: "Paiement",

        // Page détail
        backToBookings: "Retour aux réservations",
        bookingDetails: "Détails de la réservation",
        bookingInformation: "Informations de réservation",
        providerName: "Nom du fournisseur",
        passengers: "Passagers",
        holder: "Titulaire",
        years: "ans",
        cancellationPolicies: "Politiques d'annulation",
        fromDate: "À partir du",
        amount: "Montant",

        bookingTimeline: 'Chronologie de la réservation',
        flightDetails: 'Détails du Vol',
        clientAndProvider: 'Client & Fournisseur',
        generalConditions: 'Conditions générales',

        bookingCreated: 'Réservation créée',
        bookingConfirmed: 'Réservation confirmée',
        bookingCancelled: 'Réservation annulée',
        paymentDeadline: 'Date limite de paiement',

        itinerary: 'Itinéraire',
        duration: 'Durée',
        class: 'Classe',
        officeID: 'Office ID',
        fareType: 'Type de Tarif',
        gdsFare: 'GDS',

        adults: 'Adultes',
        passenger: 'passager',
        birthDate: 'Date de naissance',
        passport: 'Passeport',
        passportNumber: 'Numéro de passeport',
        expiryDate: 'Expire le',

        client: 'Client',
        accountID: 'ID Compte',

        country: 'Pays',
        destination: 'Destination',
        expiresOn: 'Expire le',

        viewVoucher: 'Voir le Ticket',
        downloadVoucher: 'Télécharger le Ticket',
        editVoucher: 'Éditer le Ticket',
        markAsPaid: 'Marquer comme payé',

        termsAndConditionsDescription: 'Les conditions générales de vente s\'appliquent à cette réservation. Consultez les détails spécifiques dans votre confirmation de réservation.',

        loading: 'Chargement...',
        bookingNotFound: 'Réservation non trouvée',
        booking: 'Réservation',
        providerAmount: 'Montant fournisseur',
        serviceFee: 'Frais de service',
        serviceType: 'Type de service',
        refundable: 'Remboursable',
        cancellationDeadline: 'Date limite d\'annulation',
        archived: 'Archivé',
        visible: 'Visible',
        emailSent: 'Email envoyé',
        invoiced: 'Facturé',
        yes: 'Oui',
        no: 'Non',
        hotelName: 'Nom de l\'hôtel',
        hotelCode: 'Code hôtel',
        confirmationNumber: 'Numéro de confirmation',
        rooms: 'Chambres',
        boardType: 'Type de forfait',
        people: 'Personnes',
        price: 'Prix',
        activityDetails: 'Détails de l\'activité',
        title: 'Titre',
        meetingPoint: 'Point de rencontre',
        dropoffPoint: 'Point de dépot',
        hours: 'heures',
        mealIncluded: 'Repas inclus',
        guideLanguage: 'Langue du guide',
        schedules: 'Horaires',
        day: 'Jour',
        startTime: 'Heure début',
        endTime: 'Heure fin',
        additionalInfo: 'Informations supplémentaires',
        specialInstructions: 'Instructions spéciales',
        viewTicket: 'Voir le ticket',
        exportDetails: 'Exporter détails',
        printItinerary: 'Imprimer itinéraire',
        passengerSummary: 'Résumé des passagers',
        infants: 'Bébés',
        officeInformation: 'Informations de l\'office',
        officeCode: 'Code office',
        airline: 'Compagnie aérienne',
        tripType: 'Type de voyage',
        oneWay: 'Aller simple',
        roundTrip: 'Aller-retour',
        flightItineraries: 'Itinéraires de Vol',
        departure: 'Départ',
        arrival: 'Arrivée',
        departureAirport: 'Aéroport de départ',
        arrivalAirport: 'Aéroport d\'arrivée',
        noFlightItineraries: 'Aucun itinéraire de vol disponible',
        additionalRemarks: 'Remarques supplémentaires',
        nationality: 'Nationalité',
        passportCountry: 'Pays du passeport',
        passportExpiry: 'Expiration passeport',
        clientInfoNotAvailable: 'Information client non disponible',
        cancellationPolicy: 'Politique d\'annulation',
        forAmount: 'pour',
        notIncluded: 'Non inclus',
        Included: 'Inclus',
        extras: 'Extras',

        //fournisseurs
        suppliersManagement: 'Gestion des Fournisseurs',
        totalSuppliers: 'Total Fournisseurs',
        allSuppliers: 'Tous les fournisseurs',
        enabledSuppliers: 'Fournisseurs Actifs',
        newSuppliers: 'Nouveaux Fournisseurs',
        pendingSuppliers: 'En attente',
        countries: 'Pays',
        operatingCountries: 'Pays d\'opération',

        // Navigation
        backToSuppliers: 'Retour aux fournisseurs',
        supplierDetails: 'Détails du fournisseur',

        // Sections
        supplierInformation: 'Informations du fournisseur',
        associatedAccounts: 'Comptes associés',
        associatedProvider: 'Fournisseurs associés',
        noAssociatedProvider: 'Pas de Fournisseurs associés',
        invoices: 'Factures',

        // Informations du fournisseur
        address: 'Adresse',
        city: 'Ville',
        creationDate: 'Date de création',
        website: 'Site web',

        // États du fournisseur
        enabled: 'Actif',
        new: 'Nouveau',
        disabled: 'Désactivé',

        // Boutons d'état
        activate: 'Activer',
        deactivate: 'Désactiver',
        reactivate: 'Réactiver',

        // Comptes associés
        administrator: 'Administrateur',
        noAssociatedAccounts: 'Aucun compte associé',

        // Factures
        addInvoice: 'Ajouter une facture',
        export: 'Exporter',
        invoiceNumber: 'Numéro',
        dueDate: 'Date d\'échéance',
        amountExclTax: 'Montant HT',
        currency: 'Devise',
        year: 'Année',

        // Résumé des factures
        totalInvoices: 'Nombre de factures',
        paidInvoices: 'Payées',
        pendingInvoices: 'En attente',
        overdueInvoices: 'En retard de paiement',
        noInvoices: 'Aucune facture',

        // Messages
        supplierStatusUpdated: 'Statut du fournisseur mis à jour',


        // Services Management
        servicesManagement: 'Gestion des Produits',

        // Filtres
        allTypes: 'Tous les types',
        clearFilters: 'Effacer les filtres',
        applyFilters: 'Appliquer les filtres',

        // Types de services
        hotel: 'Hôtel',
        activity: 'Activité',
        flight: 'Vol',
        transfer: 'Transfert',

        // Statuts
        accepted: 'Accepté',
        rejected: 'Rejeté',

        // Colonnes du tableau
        product: 'Produit',
        location: 'Emplacement',
        activeStatus: 'Statut Actif',
        completion: 'Achèvement',

        //Factures
        overdue: 'En retard',
        dueToday: 'Échéance aujourd\'hui',
        dueSoon: 'Échéance proche',
        filterByStatus: 'Filtrer par statut',
        filterByDate: 'Filtrer par date',
        showOverdue: 'Afficher les échues',
        invoicesList: 'Liste des factures',

        //details produits
        back: 'Retour',
        productDetails: 'Détails du produit',
        productNotFound: 'Produit non trouvé',
        generalInformation: 'Informations générales',
        basicInfo: 'Informations de base',
        description: 'Description',
        inclusionsExclusions: 'Inclus / Non inclus',
        items: 'Éléments',
        quickActions: 'Actions rapides',
        productName: 'Nom du produit',
        bookingMode: 'Mode de réservation',
        dates: 'Dates',
        created: 'Créé le',
        updated: 'Mis à jour le',
        shortSummary: 'Résumé court',
        fullDescription: 'Description complète',
        viewSupplier: 'Voir le fournisseur',
        viewClient: 'Voir client',
        viewBooking: 'Voir réservation',
        capacity: 'Capacité',
        seniors: 'Seniors',
        guide: 'Guide',
        languages: 'Langues',
        audioGuide: 'Guide audio',
        options: 'Options',
        privateActivity: 'Activité privée',
        dropoffLocation: 'Lieu de dépôt',
        foodIncluded: 'Repas inclus',
        transportIncluded: 'Transport inclus',
        published: 'Publié',
        instant: 'Instantané',
        included: 'Inclus',
        excluded: 'Non inclus',
        requiredItems: 'Éléments requis',
        prohibitedItems: 'Éléments interdits',
        images: 'Images',
        noImages: 'Aucune image disponible',
        uploadImages: 'Télécharger des images',
        noServiceViewAvailable: 'Aucune service disponible',

        //hotel 
        constructionYear: 'Année de construction',
        lastRenovation: 'Dernière rénovation',
        floors: 'Nombre d\'étages',
        pricingType: 'Type de tarification',
        perRoom: 'par chambre',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        minCheckInAge: 'Âge minimum pour check-in',
        amenitiesServices: 'Équipements & Services',
        roomTypes: 'Types de Chambres',
        type: 'Type',
        configuration: 'Configuration',
        beds: 'Lits',
        none: 'Aucune',
        recentRates: 'Tarifs Récentes',
        meal: 'Repas',

        //hotel view
        transferDetails: 'Détails du Transfert',
        transferInformation: 'Informations du Transfert',
        transferType: 'Type de transfert',
        availableVehicles: 'Véhicules Disponibles',
        vehicle: 'véhicule',
        tariff: 'tarif',
        amenities: 'Équipements',

        //settings
        personalInformation: 'Informations Personnelles',
        emailVerification: 'Vérification Email',
        verified: 'Vérifié',
        notVerified: 'Non vérifié',
        createdAt: 'Créé le',
        updatedAt: 'Mis à jour le',
        accountSettings: 'Paramètres du Compte',
        securitySettings: 'Sécurité',
        securitySettingsDescription: 'Gérez votre mot de passe et la sécurité de votre compte',
        profileSettings: 'Informations Personnelles',
        profileSettingsDescription: 'Modifiez vos informations de profil et de contact',
        sessions: 'Sessions',
        activeSessionsDescription: 'Voir vos sessions de connexion',
                connexions: 'Connections',
        notProvided: 'Non fourni',
        backToSettings: 'Retour aux paramètres',
        changePassword: 'Changer le mot de passe',
        currentPassword: 'Mot de passe actuel',
        enterCurrentPassword: 'Entrez votre mot de passe actuel',
        enterNewPassword: 'Entrez votre nouveau mot de passe',
        confirmNewPassword: 'Confirmez votre nouveau mot de passe',
        updating: 'Mise à jour...',
        passwordRequirements: 'Exigences du mot de passe',
        minCharacters: 'Minimum 8 caractères',
        uppercaseLowercase: 'Majuscules et minuscules',
        includeNumbers: 'Inclure des chiffres',
        includeSpecialChars: 'Inclure des caractères spéciaux',

        //sub settings
        position: 'Poste',
        editProfile: 'Modifier le profil',

    connectionHistory: 'Historique de connexion',
    mostRecent: 'Plus récente',
    connectionDate: 'Date de connexion',
    successfulConnection: 'Connexion réussie',
    failedConnection: 'Connexion échouée',
    unknownStatus: 'Statut inconnu',
    noConnectionHistory: 'Aucun historique de connexion',
    lastConnection: 'Dernière connexion',
    ipAddress: 'Adresse IP',
    dateAndTime: 'Date et heure',
    message: 'Message',

        securityInformation: 'Informations de sécurité',
sessionsSecurityInfo1: "Cette page affiche l'historique de vos connexions récentes.",
sessionsSecurityInfo2: "Vérifiez régulièrement cet historique pour détecter toute activité suspecte.",
sessionsSecurityInfo3: "Si vous remarquez une connexion inhabituelle, changez immédiatement votre mot de passe ou contactez l'équipe de sécurité.",


        customer: 'Client',

        //exchange
        currentRate: 'Taux actuel',
        copiedToClipboard: 'Copié dans le presse-papier',
        copyFailed: 'Échec de la copie',
        copyToClipboard: 'Copier le résultat',
        exchangeRateDescription: 'Convertissez rapidement vos devises avec les taux de change en temps réel',
        enterAmount: 'Entrez le montant',
        calculate: 'Calculer',
        calculating: 'Calcul en cours...',
        reset: 'Réinitialiser',
        conversionResult: 'Résultat de la conversion',
        invalidAmount: 'Veuillez entrer un montant valide',
        sameCurrency: 'Veuillez sélectionner des devises différentes',
        exchangeRateUnavailable: 'Taux de change non disponible',
        conversionSuccessful: 'Conversion effectuée avec succès',
        conversionError: 'Erreur lors de la conversion',
        saveChanges: 'Enregistrer les modifications',

        //stats
        navigation: 'Navigation',
        lastWeek: 'Semaine dernière',
        lastMonth: 'Mois dernier',
        lastQuarter: 'Trimestre dernier',
        lastYear: 'Année dernière',
        responseTime: 'Temps de réponse',
        growth: 'Croissance',

        //voucher
        voucher: 'Ticket',
        print: 'Imprimer',
        download: 'Télécharger',
        downloadPDF: 'Télécharger PDF',
        loadError: 'Erreur lors du chargement',
        generatingPDF: 'Génération du PDF...',
        pdfGenerated: 'PDF généré avec succès',
        pdfError: 'Erreur lors de la génération du PDF',
        unpaid: 'Non payé',
        refused: 'Refusé',
        expired: 'Expiré',
        extranetVoucher: 'TICKET EXTRANET',
        bookingReference: 'Référence de réservation',
        productInformation: 'Informations produit',
        providerInformation: 'Informations fournisseur',
        passengerInformation: 'Informations Passagers',
        flightInformation: 'Informations Vol',
        importantNotes: 'Notes Importantes',
        checkinDate: 'Date de check-in',
        checkoutDate: 'Date de check-out',
        bookingDate: 'Date de réservation',
        productType: 'Type de produit',
        contactEmail: 'Email de contact',
        scanQRCode: 'Scannez le QR code pour les détails de réservation',
        notePresentVoucher: 'Présentez ce ticket au fournisseur de service',
        noteKeepVoucher: 'Gardez ce ticket avec vous pendant votre voyage',
        noteEmergencyContact: 'En cas d\'urgence, contactez directement le fournisseur',
        noteCancellationPolicies: 'Les politiques d\'annulation s\'appliquent selon les conditions de réservation',
        voucherGeneratedOn: 'Ticket généré le',
        officialVoucherMessage: 'Ceci est un ticket de voyage officiel. Veuillez le conserver en sécurité.',
        generatedBy: 'Généré par',
        notAvailable: 'N/A',

        noActivityDetails: 'Aucun détail d\'activité disponible',
        priceRange: 'Fourchette de prix',
        pricingDates: 'Dates tarifées',
        babies: 'Bébés',
        durationTiming: 'Durée et planning',
        cutoffTime: 'Délai de réservation',
        arrivalTime: 'Temps d\'arrivée',
        dateRange: 'Période',
        guideInPerson: 'Guide en personne',
        drinksIncluded: 'Boissons incluses',
        stopSales: 'Arrêter',
        allAvailable: 'Tout disponible',
        adult: 'Adulte',
        child: 'Enfant',
        senior: 'Senior',
        baby: 'Bébé',
        showingFirst: 'Affichage des premiers',
        of: 'sur',
        minutes: 'minutes',
        notSpecified: 'Non spécifié',
        noPricing: 'Pas de tarification',
        productId: 'ID Produit',
        noServiceFee: 'Aucun frais de service',
        includedInPrice: 'Inclus dans le prix',
        additionalFee: 'Frais supplémentaire',
        requirements: 'Requis',
        keyPoints: 'Points clés',
        '24HourPolicy': 'Politique 24 heures',
        flexiblePolicy: 'Politique flexible',
        cancellationFee: 'Frais d\'annulation',
        freeCancellation: 'Annulation gratuite',
        noSummary: 'Aucun résumé disponible',
        noDescription: 'Aucune description disponible',
        viewBookings: 'Voir les réservations',
        editProduct: 'Éditer le produit',
        activityName: 'Nom de l\'activité',
        activityType: 'Type d\'activité',
        airlineCode: 'Code compagnie',
        segments: 'Segments',
        cabinClasses: 'Classes cabine',
        flightNumber: 'Numéro de vol',
        aircraftType: 'Type d\'appareil',
        baggageAllowance: 'Franchise bagages',
        cabinBaggage: 'Bagage cabine',
        checkedBaggage: 'Bagage en soute',
        additionalFees: 'Frais supplémentaires',
        checkinInfo: 'Informations d\'enregistrement',
        onlineCheckin: 'Enregistrement en ligne',
        airportCheckin: 'Enregistrement aéroport',
        boardingTime: 'Embarquement',
        directFlight: 'Direct',
        connectingFlight: 'Avec correspondance',
        stopovers: 'Escales',
        servicesIncluded: 'Services inclus',
        restrictions: 'Restrictions',
        economyClass: 'Classe Économique',
        businessClass: 'Classe Affaires',
        firstClass: 'Première Classe',
        premiumEconomy: 'Premium Économique',
        mealService: 'Service repas',
        entertainment: 'Divertissement à bord',
        wifi: 'WiFi à bord',
        seatSelection: 'Sélection de siège',
        noPets: 'Animaux non autorisés (sauf assistance)',
        noSmoking: 'Interdiction de fumer',
        liquidsLimit: 'Limite liquides 100ml en cabine',
        noFlightDetails: 'Aucun détail de vol disponible',
        noHotelDetails: 'Aucun détail d\'hôtel disponible',
        restaurants: 'Restaurants',
        swimmingPools: 'Piscines',
        perPerson: 'Par personne',
        mealAgeRequirement: 'Âge minimum repas',
        checkinTime: 'Heure d\'arrivée',
        checkoutTime: 'Heure de départ',
        basicServices: 'Services de base',
        reception24h: 'Réception 24h/24',
        virtualReception: 'Réception virtuelle',
        welcomeService: 'Service d\'accueil',
        earlyArrival: 'Arrivée anticipée',
        lateArrival: 'Arrivée tardive',
        internetConnection: 'Connexion Internet',
        welcomeProcedures: 'Procédures d\'accueil',
        physicalCheckin: 'Check-in physique',
        virtualCheckin: 'Check-in virtuel',
        internetServices: 'Services Internet',
        wifiFree: 'Wi-Fi gratuit',
        wifiPaid: 'Wi-Fi payant',
        parkingServices: 'Services parking',
        parkingFree: 'Parking gratuit',
        parkingPaid: 'Parking payant',
        outdoorPool: 'Piscine extérieure',
        indoorPool: 'Piscine intérieure',
        accessibility: 'Accessibilité',
        accessibilityOption: 'Option accessibilité',
        roomAmenities: 'Équipements chambre',
        roomAmenity: 'Équipement chambre',
        generalServices: 'Services généraux',
        generalService: 'Service général',
        sportsActivities: 'Activités sportives',
        sport: 'Sport',
        equipment: 'Équipement',
        wellnessServices: 'Services bien-être',
        wellnessService: 'Service bien-être',
        businessServices: 'Services affaires',
        businessService: 'Service affaires',
        familyRomanticServices: 'Services familliaux',
        familyService: 'Service famille',
        natureEnvironment: 'Nature et Environnement',
        natureService: 'Service nature',
        hotelDetails: 'Détails de l\'hôtel',
        detailedServices: 'Services détaillés',
        sportService: 'Service sportif',

        nights: 'Nuits',
        roomsCount: 'Nombre de chambres',
        adultCount: 'Nombre d\'adultes',
        childCount: 'Nombre d\'enfants',
        roomType: 'Type de chambre',
        roomCount: 'Nombre de chambres',
        amountProvider: 'Montant fournisseur',
        mealPlan: 'Type de pension',
        mealType: 'Type de repas',
        children: 'Enfants',

        holderInformation: 'Informations du Titulaire',
        male: 'Homme',
        female: 'Femme',
        countryOfResidence: 'Pays de résidence',
        passportExpiration: 'Expiration du passeport',
        voucherCustomizer: 'Personnalisateur de ticket',
        undo: 'Annuler',
        redo: 'Rétablir',
        exportPDF: 'Exporter PDF',
        saveConfiguration: 'Enregistrer la configuration',

        logoConfiguration: 'Configuration du logo',
        showLogo: 'Afficher le logo',
        uploadLogo: 'Télécharger un logo',
        removeLogo: 'Supprimer le logo',
        logoPreview: 'Aperçu du logo',
        logoPosition: 'Position du logo',
        logoSize: 'Taille du logo',
        logoOpacity: 'Opacité du logo',
        companyLogo: 'Logo de l\'entreprise',

        // Positions
        topLeft: 'En haut à gauche',
        topCenter: 'En haut au centre',
        topRight: 'En haut à droite',
        bottomLeft: 'En bas à gauche',
        bottomCenter: 'En bas au centre',
        bottomRight: 'En bas à droite',
        diagonal: 'Diagonale',
        repeat: 'Répéter',
        corner: 'Coin',

        // Sizes
        small: 'Petit',
        medium: 'Moyen',
        large: 'Grand',

        // Watermark
        watermarkConfiguration: 'Configuration du filigrane',
        showWatermark: 'Afficher le filigrane',
        watermarkType: 'Type de filigrane',
        textWatermark: 'Filigrane texte',
        imageWatermark: 'Filigrane image',
        watermarkText: 'Texte du filigrane',
        enterWatermarkText: 'Entrez le texte du filigrane...',
        uploadWatermarkImage: 'Télécharger une image de filigrane',
        removeWatermark: 'Supprimer le filigrane',
        watermarkPreview: 'Aperçu du filigrane',
        watermarkPosition: 'Position du filigrane',
        watermarkOpacity: 'Opacité du filigrane',
        watermarkRotation: 'Rotation du filigrane',
        watermarkSize: 'Taille du filigrane',
        watermark: 'Filigrane',

        // Messages
        fileTooLarge: 'Le fichier est trop volumineux',
        logoUploaded: 'Logo téléchargé avec succès',
        watermarkUploaded: 'Filigrane téléchargé avec succès',
        logoRemoved: 'Logo supprimé',
        watermarkRemoved: 'Filigrane supprimé',
        voucherHeader: 'En-tête du ticket',
        qrCode: 'Code QR',
        footer: 'Pied de page',

        customQrCode: 'QR Code Personnalisé',
        useCustomQrCode: 'Utiliser un QR code personnalisé',
        uploadQrCodeImage: 'Télécharger une image QR code',
        removeQrCode: 'Supprimer le QR code',
        qrCodePreview: 'Aperçu du QR code',
        qrCodeSize: 'Taille du QR code',
        qrCodeBorderRadius: 'Arrondi du QR code',
        showShadow: 'Afficher l\'ombre',
        qrCodeMessage: 'Message sous le QR code',
        enterQrMessage: 'Entrez le message à afficher...',
        uploadCenterLogo: 'Logo au centre du QR code',
        qrCodePlaceholder: 'QR Code\n(Uploader votre propre QR code)',
        encodedInformation: 'Informations encodées',
        qrCodeInstructions: 'Instructions pour le QR code',
        qrInstruction1: 'Générez votre QR code avec un service en ligne',
        qrInstruction2: 'Assurez-vous qu\'il est de bonne qualité (300x300px min)',
        qrInstruction3: 'Le QR code doit contenir les informations de réservation',
        qrInstruction4: 'Format supporté: PNG, JPG, SVG',
        uploaded: 'Uploadé',


        noSectionsAdded: 'Aucune section ajoutée. Utilisez le panneau de gauche pour ajouter des sections au voucher.',
        customize: 'Personnaliser',
        customizeVoucher: 'Personnaliser le voucher',
        sections: 'Sections',
        dragToReorder: 'Glisser pour réorganiser',
        layoutConfigTitle: 'Configuration de la mise en page',
        layoutTypeLabel: 'Type de mise en page',
        layoutVertical: 'Vertical',
        layoutGrid: 'Grille',
        columnCountLabel: 'Nombre de colonnes',
        resetLayoutButton: 'Réinitialiser la mise en page',
        appearanceTitle: 'Apparence',
        primaryColorLabel: 'Couleur primaire',
        backgroundColorLabel: 'Couleur de fond',
        fontSizeLabel: 'Taille de police',
        fontSizeSmall: 'Petite',
        fontSizeLarge: 'Grande',
        spacingLabel: 'Espacement',
        borderRadiusLabel: 'Arrondi des bordures',
        fontFamilyLabel: 'Police de caractères',
        fontPreview: 'Aperçu de la police',

        chooseFile: 'Choisir un fichier',
        headerLogo: 'Logo en-tête',
        footerLogo: 'Logo pied de page',
        customLogo: 'Logo personnalisé',
        left: 'Gauche',
        center: 'Centre',
        right: 'Droite',
        opacity: 'Opacité',

        headerLogoSettings: 'Paramètres de l\'en-tête',
        footerLogoSettings: 'Paramètres du pied de page',
        customLogoSettings: 'Paramètres du logo personnalisé',
        positionLabel: 'Position',
        sizeLabel: 'Taille',

        currencies: "Devises",
        differentCurrencies: "Devises différentes",

        nonRefundable: 'Non remboursable',
        bookingHistory: 'Historique de réservation',
        paymentInformation: 'Informations de paiement',
        residenceCountry: 'Pays de résidence',
        noConditions: 'Aucune condition',
        chargeService: 'Frais de service',
        providerInfoNotAvailable: 'Information fournisseur non disponible',
        customerAccount: 'Compte client',
        providerPaymentStatus: 'Statut paiement fournisseur',
        chargeServiceType: 'Type de frais de service',
        totalPassengers: 'Total passagers',

        room: 'Chambre',
        providerType: 'Type de fournisseur',
        gender: 'Genre',
        hotelInformation: 'Informations hôtel',
        occupants: 'Occupants',
        roomDetails: 'Détails de la chambre',
        servicesInclusionsExclusions: 'Détails Services',
        guestInformation: 'Informations Invités',
        hotelVoucher: 'TICKET HÔTEL',
        flightVoucher: 'TICKET VOL',
        transferVoucher: 'TICKET TRANSFERT',
        activityVoucher: 'TICKET ACTIVITE',
        padding: 'Marge',

            cancellationNotes: 'Notes d\'Annulation',
    enableCancellationNotes: 'Activer les notes d\'annulation',
    customCancellationPolicy: 'Politique d\'annulation personnalisée',
    enterCustomPolicy: 'Entrez votre politique d\'annulation personnalisée...',
    cancellationNotesList: 'Notes d\'annulation',
    noCancellationNotes: 'Aucune note d\'annulation ajoutée',
    addNewNote: 'Ajouter une nouvelle note',
    enterNoteText: 'Entrez le texte de la note...',
    predefinedNotes: 'Notes prédéfinies',
    nonRefundableAfter24h: 'Non-remboursable 24h après la réservation',
    freeCancellationBefore48h: 'Annulation gratuite jusqu\'à 48h avant',
    partialRefund70percent: 'Remboursement partiel de 70% avant 7 jours',
    administrativeFees50: 'Frais administratifs de 50€ pour toute annulation',
    showSystemCancellationInfo: 'Afficher les informations système',
    confirmRemoveAllNotes: 'Supprimer toutes les notes ?',
    removeAllNotes: 'Supprimer toutes les notes',
    removeNote: 'Supprimer la note',
    add: 'Ajouter',

        notesCustomization: 'Personnalisation des Notes',
    showNotesCustomization: 'Afficher la personnalisation des notes',
    notesList: 'Liste des notes',
    emergencyContact: 'Contact d\'urgence',
    enterEmergencyContact: 'Entrez un contact d\'urgence...',
    showGenerationDate: 'Afficher la date de génération',
    resetToDefaultNotes: 'Rétablir les notes par défaut',
    confirmResetToDefault: 'Rétablir les notes par défaut ?',
        officialRate: 'Taux officiel',
    parallelRate: 'Taux parallèle',
    manageRates: 'Gérer les taux',
    manageParallelRates: 'Gérer les taux de change parallèles',
    usingParallelRates: 'Utilisation de taux de change parallèles personnalisés',
    saveRate: 'Enregistrer le taux',
    savedRates: 'Taux enregistrés',
    noSavedRates: 'Aucun taux personnalisé enregistré',
    remove: 'Supprimer',
    invalidRate: 'Veuillez entrer un taux valide',
    rateUpdated: 'Taux mis à jour avec succès',
    rateReset: 'Taux réinitialisé à la valeur officielle',
    to: 'À',

        manageExchangeRates: 'Gérer les Taux de Change',
    loadingRates: 'Chargement des taux de change',
    errorLoadingRates: 'Erreur lors du chargement des taux',
    rateSaved: 'Taux de change enregistré avec succès',
    saveError: 'Erreur lors de l\'enregistrement du taux',
    rateDeleted: 'Taux de change supprimé',
    deleteError: 'Erreur lors de la suppression du taux',
    saving: 'Enregistrement',
    noRatesSaved: 'Aucun taux de change enregistré',

        officialRates: 'Taux officiels',
    parallelRates: 'Taux parallèles',
    manageAllRates: 'Gérer tous les taux de change',
    addNewRate: 'Ajouter un nouveau taux',
    addRate: 'Ajouter le taux',
    noRatesAvailable: 'Aucun taux disponible',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce taux de change ?',

        errorLoadingCountries: 'Erreur lors du chargement de la liste des pays',
    errorLoadingProviders: 'Erreur lors du chargement de la liste des fournisseurs',
    salesStatus: 'État des ventes',
    averageRevenue: 'Revenu moyen',
    cancellationRate: 'Taux d\'annulation',
    confirmedAndCancelled: 'Confirmées & Annulées',
    perBooking: 'Par réservation',
    ofTotalBookings: 'Des réservations totales',
    filters: 'Filtres',
    dateFrom: 'Date de début',
    dateTo: 'Date de fin',
    allProviders: 'Tous les fournisseurs',
    allCountries: 'Tous les pays',
    resetFilters: 'Réinitialiser les filtres',
    loadingData: 'Chargement des données',
    noDataDescription: 'Aucune donnée de vente trouvée pour les filtres sélectionnés.',
    exportingData: 'Exportation des données...',
    package: 'Forfait',
    partial: 'Partiel',

        salesDetails: 'Détails des ventes',
    allBookings: 'Toutes les réservations',
    uniqueServices: 'Services',
    differentServiceTypes: 'Différents types de services',
    uniqueProviders: 'Fournisseurs',
    ofTotal: 'du total',
    revenueDetails: 'Détails des revenus',
    averagePerBooking: 'Moyenne par réservation',
    dataGeneratedOn: 'Données générées le',
    providerRevenue: 'Revenus du fournisseur',

        exportExcel: 'Exporter vers Excel (.xlsx)',
    exportCSV: 'Exporter vers CSV (.csv)',
    exportSuccess: 'Fichier Excel exporté avec succès !',
    exportCSVSuccess: 'Fichier CSV exporté avec succès !',
    exportError: 'Erreur lors de l\'exportation des données',
    noDataToExport: 'Aucune donnée à exporter',
    filtersApplied: 'Filtres appliqués',
    salesData: 'Données de vente',
    dateGenerated: 'Date de génération',
    unique: 'Unique',

        exportToExcel: 'Exporter vers Excel',
    totalBookingsDesc: 'Nombre total de réservations effectuées.',
    confirmedBookingsDesc: 'Nombre de réservations qui ont été confirmées.',
    cancelledBookingsDesc: 'Nombre de réservations qui ont été annulées.',
    filterActive: 'Filtre actif',

        cancelBooking: 'Annuler la réservation',
    cancelling: 'Annulation en cours...',
    confirmCancelBooking: 'Êtes-vous sûr de vouloir annuler cette réservation ?',
    enterCancelNote: 'Veuillez saisir une note expliquant la raison de l\'annulation :',
    pleaseEnterCancelNote: 'Veuillez saisir une note pour l\'annulation',
    bookingCancelledSuccess: 'Réservation annulée avec succès',
    cancelBookingError: 'Erreur lors de l\'annulation de la réservation',
    allConditions: 'Toutes les conditions',
    loadingConditions: 'Chargement des conditions...',
    providerDeadline: 'Date limite fournisseur',
    customerDeadline: 'Date limite client',
    customerAmount: 'Montant client',

        includedServices: 'Services inclus',
    excludedServices: 'Services exclus',
    generalPolicies: 'Politiques générales',
    noIncludedServices: 'Aucun service inclus',
    noExcludedServices: 'Aucun service exclus',
    noCancellationPolicy: 'Aucune politique d\'annulation',
    noGeneralPolicies: 'Aucune politique générale',
    existingConditions: 'Conditions existantes',

        enterPhone: 'Entrez le numéro de téléphone',
    phoneExample: 'Ex: +33 1 23 45 67 89',
    enterWebsite: 'Entrez le site web',
    enterAddress: 'Entrez l\'adresse',
    charges: 'Frais',
    chargesExample: 'Ex: Frais de service 10%, Frais de traitement 5%',
    supplierUpdatedSuccess: 'Fournisseur mis à jour avec succès',
    addSupplier: 'Ajouter un fournisseur',

        backToUsers: 'Retour aux utilisateurs',
    userNotFound: 'Utilisateur non trouvé',
    userInformation: 'Informations utilisateur',
    lastActivity: 'Dernière activité',
    permissions: 'Permissions',
    registeredOn: 'Inscrit le',
    sessionLogs: 'Logs de session',
    exportLogs: 'Exporter les logs',
    totalSessions: 'Sessions totales',
    successful: 'Réussies',
    failed: 'Échouées',
    last24Hours: 'Dernières 24 heures',
    dateTime: 'Date et heure',
    noSessionLogs: 'Aucun log de session',
    sessionLogsWillAppear: 'Les logs de session apparaîtront ici',
    success: 'Succès',
    errorLoadingUser: 'Erreur lors du chargement de l\'utilisateur',
    userStatusUpdated: 'Statut de l\'utilisateur mis à jour',
    resetPasswordFeature: 'Fonctionnalité de réinitialisation du mot de passe',

        enabledUsers: 'Utilisateurs activés',
    disabledUsers: 'Utilisateurs désactivés',
    activeUsers: 'Tous les utilisateurs actifs',
    inactiveUsers: 'Tous les utilisateurs inactifs',
    editSupplier: 'Modifier le fournisseur',
    errors: 'Erreurs',
    addressRequired: 'Adresse requise',
    supportService: 'Service de support',
        loadingProfile: 'Chargement du profil...',
    errorFetchingProfile: 'Erreur lors de la récupération du profil',
    errorUpdatingProfile: 'Erreur lors de la mise à jour du profil',
    updateRequestError: 'Erreur lors de l\'envoi de la demande de mise à jour.',
    tokenEmailSent: 'Un email contenant un code de validation a été envoyé à votre adresse email. Veuillez saisir le code ci-dessous.',
    enterValidationCode: 'Veuillez saisir le code de validation.',
    profileUpdatedSuccess: 'Votre profil a été mis à jour avec succès !',
    invalidValidationCode: 'Code de validation incorrect.',
    errorValidatingToken: 'Erreur lors de la validation du token',
    validationErrorTryAgain: 'Erreur lors de la validation. Veuillez réessayer.',
    unknownDate: 'Date inconnue',
    validationRequired: 'Validation requise',
    enterValidationCodeEmail: 'Saisissez le code de validation envoyé à votre adresse email :',
    tokenPlaceholder: 'Ex: ABC123',
    validating: 'Validation en cours...',
    validated: 'Validé',
    validateCode: 'Valider le code',

        currentPasswordRequired: 'Le mot de passe actuel est requis',
    newPasswordRequired: 'Le nouveau mot de passe est requis',
    confirmPasswordRequired: 'La confirmation du mot de passe est requise',
    passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    errorUpdatingPassword: 'Erreur lors de la mise à jour du mot de passe',
    passwordUpdateError: 'Erreur lors de la mise à jour du mot de passe',
    tokenEmailSentPassword: 'Un email contenant un code de validation a été envoyé à votre adresse email. Veuillez saisir le code ci-dessous pour valider le changement de mot de passe.',
    passwordUpdatedSuccess: 'Votre mot de passe a été mis à jour avec succès !',

        resetUserPassword: 'Réinitialiser le mot de passe utilisateur',
    resetPasswordWarning: 'ATTENTION : Cette action va générer un nouveau mot de passe aléatoire et l\'envoyer par email à l\'utilisateur. L\'utilisateur devra utiliser ce mot de passe pour sa prochaine connexion.',
    enterUserId: 'Entrez l\'ID utilisateur',
    resetPasswordConfirm: 'Confirmer la réinitialisation',
    resetPasswordConfirmation: 'Êtes-vous sûr de vouloir réinitialiser le mot de passe de l\'utilisateur',
    resetPasswordInstructions: 'Un email contenant le nouveau mot de passe sera envoyé à l\'adresse email de l\'utilisateur.',
    confirmReset: 'Confirmer la réinitialisation',
    resetting: 'Réinitialisation en cours...',
    resetPasswordSuccess: 'Un nouveau mot de passe a été généré et envoyé par email à l\'utilisateur.',
    resetPasswordError: 'Erreur lors de la réinitialisation du mot de passe. Veuillez vérifier l\'ID utilisateur.',
    resetPasswordApiError: 'Erreur API lors de la réinitialisation du mot de passe',

        itemsPerPage: 'Éléments par page',
    showing: 'Affichage',
    first: 'Premier',
    previous: 'Précédent',
    next: 'Suivant',
    last: 'Dernier',

        totalCustomers: 'Clients totaux',
    allPlatformCustomers: 'Tous les clients de la plateforme',
    enabledCustomers: 'Clients activés',
    activeCustomers: 'Clients actifs',
    disabledCustomers: 'Clients désactivés',
    inactiveCustomers: 'Clients inactifs',
    pendingCustomers: 'Clients en attente',
    waitingCustomers: 'Clients en attente',
    customersManagement: 'Gestion des clients',
    deposit: 'Dépôt',

        addCustomer: 'Ajouter un client',
    editCustomer: 'Modifier le client',
    basicInformation: 'Informations de base',
    suspended: 'Suspendu',
    addressInformation: 'Informations d\'adresse',
    postalCode: 'Code postal',
    postcode: 'Code postal',
    selectCountry: 'Sélectionnez un pays',
    selectCity: 'Sélectionnez une ville',
    enterPostalCode: 'Entrez le code postal',
    enterPostcode: 'Entrez le code postal',
    selectCountryFirst: 'Sélectionnez d\'abord un pays',
    commissionAndPayment: 'Commission et paiement',
    commissionHotel: 'Commission hôtel',
    commissionFlight: 'Commission vol',
    commissionTransfer: 'Commission transfert',
    commissionActivity: 'Commission activité',
    balance: 'Solde',
    language: 'Langue',
    features: 'Fonctionnalités',
    hasHotel: 'A des hôtels',
    hasFlight: 'A des vols',
    hasTransfer: 'A des transferts',
    hasActivity: 'A des activités',
    hasBooking: 'A des réservations',
    paymentOptions: 'Options de paiement',
    payWithCreditCard: 'Payer par carte de crédit',
    payWithDeposit: 'Payer avec dépôt',
    confirmRefundableBooking: 'Confirmer réservation remboursable',
    notes: 'Notes',
    enterNotes: 'Entrez des notes',
    customerUpdatedSuccessfully: 'Client mis à jour avec succès',
    errorLoadingCities: 'Erreur lors du chargement des villes',

        selectFeatures: 'Sélectionnez les fonctionnalités',
    selectPaymentOptions: 'Sélectionnez les options de paiement',
    commissionMaxError: 'La commission ne peut pas dépasser 100%',
    customers: 'Clients',

        commissions: 'Commissions',
    financialInformation: 'Informations financières',
    documents: 'Documents',
    docMandatory: 'Document obligatoire',
    docIataAgreement: 'Accord IATA',
    docTradeLicence: 'Licence commerciale',
    noNotes: 'Aucune note',
    createdOn: 'Créé le',
    userName: 'Nom d\'utilisateur',
    superAdmin: 'Super administrateur',
    customerStatusUpdated: 'Statut du client mis à jour',
    errorUpdatingStatus: 'Erreur lors de la mise à jour du statut',
    customerUpdatedSuccess: 'Client mis à jour avec succès',
    errorLoadingCustomer: 'Erreur lors du chargement du client',

        customerInformation: 'Informations client',
    backToCustomers: 'Retour aux clients',
    customerNotFound: 'Client non trouvé',
        outbound: 'Aller',
    return: 'Retour',
    addToCalendar: 'Ajouter au calendrier',

        oneWayTransfer: 'Transfert Aller Simple',
    roundTripTransfer: 'Transfert Aller-Retour',
    forFlight: 'Pour Vol',
    viewRoute: 'Voir l\'itinéraire',
    contactDriver: 'Contacter le chauffeur',
    passengerCapacity: 'Capacité passagers',
    adultPassengers: 'Passagers adultes',
    childPassengers: 'Passagers enfants',
    passengersTotal: 'Total passagers',
    vehicleCapacity: 'Capacité du véhicule',
    seats: 'Places',
    transferItinerary: 'Itinéraire de transfert',
    updateTime: 'Temps de mise à jour',
    airportTransfer: 'Transfert aéroport',
    generalTransfer: 'Transfert général',
    pickup: 'Prise en charge',
    transferRoute: 'Itinéraire de transfert',
    dropoff: 'Dépose',
    vehicleDetails: 'Détails du véhicule',
    brand: 'Marque',
    model: 'Modèle',
    luggageCapacity: 'Capacité bagages',
    bags: 'bagages',
    persons: 'personnes',
    schedule: 'Horaire',
    travelType: 'Type de voyage',
    travelNumber: 'Numéro de voyage',
    locations: 'Lieux',
    origin: 'Origine',
    allCurrencies: 'Toutes les devises',
        fees: 'Frais',
    providerFees: 'Frais fournisseur',
    deadline: 'Date limite',
    fullName: 'Nom complet',

        flightTransfer: 'Transfert pour vol',
    trainTransfer: 'Transfert pour train',
    vehicleInformation: 'Informations véhicule',
    vehicleType: 'Type de véhicule',
    date: 'Date',
        contactInformation: 'Informations de contact',
    productInfo: 'Produit',
    customerService: 'Service client',
    contactNote: 'Pour toute question concernant votre réservation, veuillez contacter le service approprié ci-dessus.',

        activityInformation: 'Informations activité',
    contactPhone: 'Téléphone de contact',
    passengerBreakdown: 'Détail des passagers',
    durationAndPrice: 'Durée & Prix',
    activityPrice: 'Prix de l\'activité',
    detailedPrices: 'Prix détaillés',
    priceItem: 'Article prix',
    noDetailedPrices: 'Pas de montants détaillés',

        totalPrice: 'Prix total',
    days: 'jour(s)',
    totalParticipants: 'Total participants',
    locationDetails: 'Détails du lieu',
    coordinates: 'Coordonnées',
    detailedPricing: 'Tarification détaillée',
    description: 'Description',
    priceIncludesAll: 'Tous les services et frais sont inclus dans le prix total',
    backToDetails: 'Retour aux détails',
    participantBreakdown: 'Répartition des participants',

        activationEmailSent: 'Email d\'activation envoyé',
            activationInitiated: 'Activation initiée',
    activationLinkSentToSupplier: 'Lien d\'activation envoyé au fournisseur',

        occupancy: 'Occupation',
    pricePerNight: 'Prix/nuit',
    nightlyPrices: 'Prix par nuit',
    rateComments: 'Commentaires sur les tarifs',
    exclusions: 'Exclusions',
    inclusions: 'Inclusions',
    viewAmenties: 'Voir les équipements',

        occupancyAndMeal: 'Occupants & Repas',
    totalOccupants: 'Total occupants',
    providerPrice: 'Prix fournisseur',
    moreNights: 'nuits supplémentaires',

        stayPeriod: 'Période de séjour',
    occupancyDetails: 'Détails d\'occupation',
    occupants: 'Occupants',
    additionalInformation: 'Informations complémentaires',

         sectionColorLabel: 'Couleur de section',
    textColorLabel: 'Couleur du texte',
    secondaryColorLabel: 'Couleur secondaire',

        statusFilter: 'Filtre par statut',
    invoiceNumberFilter: 'Filtre par numéro de facture',
    exportInformation: 'Informations d\'exportation',
    exportDate: 'Date d\'exportation',
    paid_at: 'Payé le',
    createFirstInvoice: 'Créer la première facture',

        addNewInvoice: 'Ajouter une nouvelle facture',
    findBookings: 'Trouver des réservations',
    searchFilters: 'Filtres de recherche',
    searchBookings: 'Rechercher des réservations',
    searching: 'Recherche en cours...',
    selectBookings: 'Sélectionner des réservations',
    selected: 'sélectionné(s)',
    selectAll: 'Tout sélectionner',
    bookings: 'Réservations',
    bookingsFound: 'réservation(s) trouvée(s)',
    noBookingsFound: 'Aucune réservation trouvée',
    noBookingsAvailable: 'Aucune réservation disponible',
    useFiltersAboveToFindBookings: 'Utilisez les filtres ci-dessus pour trouver des réservations',
    invoiceNotesPlaceholder: 'Notes supplémentaires pour la facture...',
    selectedBookings: 'Réservations sélectionnées',
    vatAmount: 'Montant TVA',
    totalWithTax: 'Total TTC',
    creating: 'Création en cours...',
    createInvoice: 'Créer la facture',
    selectCustomer: 'Sélectionner un client',
    selectService: 'Sélectionner un service',
    dateType: 'Type de date',
    loadingBookings: 'Chargement des réservations',
    errorLoadingCustomers: 'Erreur lors du chargement des clients',
    errorLoadingServices: 'Erreur lors du chargement des services',
    errorLoadingBookings: 'Erreur lors du chargement des réservations',
    errorCreatingInvoice: 'Erreur lors de la création de la facture',
    pleaseFillAllFilters: 'Veuillez remplir tous les filtres',
    selectAtLeastOneBooking: 'Sélectionnez au moins une réservation',
    invoiceNumberRequired: 'Le numéro de facture est requis',
    invoiceCreatedSuccess: 'Facture créée avec succès !',
    invoiceDetails: 'Détails de la facture',

        allCustomers: 'Tous les clients',
    invoiceCreated: 'Facture créée !',
    configureSearchFilters: 'Configurer les filtres de recherche',
    customersFound: 'client(s) trouvé(s)',
    searchError: 'Erreur lors de la recherche',
    pleaseSelectDates: 'Veuillez sélectionner les dates',
    confirmInvoiceCreation: 'Confirmer la création de la facture',
    summary: 'Résumé',
    dueDate: 'Date d\'échéance',
    invoiceCreationConfirmation: 'La facture sera créée avec les réservations sélectionnées.',
    selectDueDate: 'Veuillez sélectionner une date d\'échéance',
    confirm: 'Confirmer',

        invoices: 'Factures',
    customerInvoices: 'Factures Clients',
    providerInvoices: 'Factures Fournisseurs',
    noCustomerInvoices: 'Aucune facture client trouvée',
    noProviderInvoices: 'Aucune facture fournisseur trouvée',
    useFiltersOrAddInvoice: 'Utilisez les filtres ou ajoutez une facture',
    useFiltersToFindInvoices: 'Utilisez les filtres pour trouver des factures',
    exportInProgress: 'Export en cours...',
    errorLoadingCustomerInvoices: 'Erreur lors du chargement des factures clients',
    errorLoadingProviderInvoices: 'Erreur lors du chargement des factures fournisseurs',
    period: 'Période',
    pendingAmount: 'Montant en attente',
    needAttention: 'Nécessite attention',
    totalByCurrency: "Total par Devise",

        backToInvoices: 'Retour aux factures',
    providerInvoice: 'Facture fournisseur',
    customerInvoice: 'Facture client',
    invoiceDetail: 'Détail de la facture',
    paidDate: 'Date de paiement',
    invoiceID: 'ID de la facture',
    financialDetails: 'Détails financiers',
    invoicePaid: 'Facture payée',
    invoiceUnpaid: 'Facture impayée',
    invoiceOverdue: 'Facture en retard',
    paidOn: 'Payé le',
    dueOn: 'Échéance le',
    overdueSince: 'En retard depuis',
    share: 'Partager',
    duplicate: 'Dupliquer',
    exportBookings: 'Exporter les réservations',
    invoiceDates: 'Dates de la facture',
    invoiceDate: 'Date de la facture',

        exportBookingsSelection: 'Sélection des réservations pour l\'export',
    search: 'Rechercher',
    searchBookingsPlaceholder: 'Rechercher par numéro, titulaire ou service...',
    section: 'Section',
    zipCode: 'Code postal',
    serviceName: 'Nom du service',
    rateId: 'ID du tarif',
    bookingId: 'ID de réservation',
    invoiceInfo: 'Informations facture',
    selected: 'Sélectionné(s)',
    deselectAll: 'Tout désélectionner',
    exportSelected: 'Exporter la sélection',
    noBookingsSelected: 'Aucune réservation sélectionnée',

    invoiceInformation: 'Information de la facture',
company: 'Entreprise',

    invoice: 'Facture',
    summary: 'Récapitulatif',
    pending: 'En attente',
    serviceType: 'Type',
    checkinDate: 'Date d\'arrivée',
    checkoutDate: 'Date de départ',
    totalBookings: 'Total réservations',
    exportGeneratedOn: 'Export généré le',
    document: 'Document',
    exportType: 'Type d\'export',
    exportPdfSuccess: 'PDF exporté avec succès',
    exportPdfError: 'Erreur lors de l\'export PDF',

    exportToPDF: 'Exporter en PDF',

    
        // Mois
        jan: 'Jan',
        feb: 'Fév',
        mar: 'Mar',
        apr: 'Avr',
        may: 'Mai',
        jun: 'Juin',
        jul: 'Juil',
        aug: 'Aoû',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Déc',

        // Jours 
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',

        // Expressions temporelles
        minutesAgo: 'Il y a {{count}} min',
        hoursAgo: 'Il y a {{count}}h',
        daysAgo: 'Il y a {{count}} jour(s)',

        // pays 
        france: 'France',
        spain: 'Espagne',
        germany: 'Allemagne',
        italy: 'Italie'
    },
    en: {
        dashboard: 'Dashboard',
        management: 'Management',
        finance: 'Finance',
        support: 'Support',
        authentication: 'Authentication',
        settings: 'Settings',
        users: 'Users',
        suppliers: 'Suppliers',
        exchangeRate: 'Exchange Rate',
        sales: 'Sales Status',
        reservations: 'Reservations',
        products: 'Products',
        promotions: 'Promotions',
        statistics: 'Statistics',
        adminSupport: 'Admin Support',
        supplierSupport: 'Supplier Support',
        welcome: 'Welcome',
        overview: 'Overview',
        logout: 'Logout',
        profile: 'Profile',
        revenue: 'Revenue',
        newUsers: 'New users',
        activeSuppliers: 'Active suppliers',
        productsInStock: 'Products in stock',
        todaysRevenue: "Today's revenue",
        monthlyRevenue: 'Monthly revenue',
        unpaidInvoices: 'Unpaid invoices',
        conversionRate: 'Conversion rate',
        thisWeek: 'This week',
        total: 'Total',
        available: 'Available',
        thisMonth: 'This month',
        recentActivity: 'Recent activity',
        supportTickets: 'Support tickets',
        createdProduct: 'created a new product',
        madeReservation: 'made a reservation',
        updatedPromotion: 'updated a promotion',
        addedSupplier: 'added a supplier',
        pricing: 'Pricing',
        supplier: 'Supplier',
        generatedInvoice: 'generated an invoice',
        paymentIssue: 'Payment issue',
        productQuestion: 'Product question',
        refundRequest: 'Refund request',
        adminInterfaceBug: 'Admin interface bug',
        urgent: 'Urgent',
        pending: 'Pending',
        resolved: 'Resolved',
        high: 'High',
        low: 'Low',
        globalStatistics: 'Global Statistics',
        salesEvolution: 'Sales Evolution',
        id: 'ID',
        subject: 'Subject',
        priority: 'Priority',
        time: 'Time',
        enter: 'Enter',
        searchSectionPlaceholder: 'Search a section...',
        main: 'Main',

        keyMetrics: 'Key Metrics',
        totalProducts: 'Total products',
        pendingPayment: 'Pending payment',
        supportRequests: 'Support requests',
        salesByCountry: 'Sales by country',
        other: 'Other',
        topSellingProducts: 'Top selling products',
        connectedUsers: 'Connected users',
        online: 'Online',
        away: 'Away',
        trendingSearches: 'Trending searches',
        searches: 'searches',
        agenda: 'Agenda',
        participants: 'participants',
        meeting: 'meeting',
        presentation: 'presentation',
        review: 'review',
        training: 'training',
        teamMeeting: 'Team meeting',
        clientPresentation: 'Client presentation',
        productReview: 'Product review',
        trainingSession: 'Training session',
        deliveryProblem: 'Delivery problem',
        technicalSupport: 'Technical support',
        openTickets: 'Open tickets',
        gender: 'Gender',


        // Login translations
        login: "Login",
        forgotPassword: "Forgot Password",
        password: "Password",
        rememberMe: "Remember me",
        loginButton: "Sign in",
        noAccount: "Don't have an account?",
        signUp: "Sign up",
        forgotPasswordLink: "Forgot password?",
        backToLogin: "Back to login",
        resetPassword: "Reset Password",
        sendResetLink: "Send reset link",
        resetEmailSent: "A reset email has been sent",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        updatePassword: "Update password",
        passwordUpdated: "Password updated successfully",
        emailPlaceholder: "your@email.com",
        passwordPlaceholder: "Enter your password",
        passwordRequired: "Password is required",
        invalidEmail: "Invalid email",
        passwordTooShort: "Password must be at least 6 characters",
        passwordsDontMatch: "Passwords don't match",
        loginError: "Incorrect email or password",
        resetPasswordTitle: "Reset your password",
        resetPasswordDesc: "Enter your email to receive a reset link",
        updatePasswordTitle: "Create new password",
        updatePasswordDesc: "Enter your new password",
        passwordUpdateSuccess: "Your password has been updated successfully. You can now log in with your new password.",

        // Users Page
        usersManagement: "Users Management",
        addUser: "Add User",

        // Statistics cards
        totalUsers: "Total Users",
        allPlatformUsers: "All platform users",
        currentlyOnline: "Currently online",
        administrators: "Administrators",
        usersWithAdminRights: "Users with admin rights",
        otherUsers: "Other Users",
        standardUsers: "Standard users",

        // Table columns
        name: "Name",
        email: "E-mail",
        role: "Role",
        status: "Status",
        lastLogin: "Last Login",
        department: "Department",
        phone: "Phone",

        // Actions and messages
        confirmDeleteUser: "Are you sure you want to delete this user?",
        editUser: "Edit User",
        deleteUser: "Delete User",
        viewDetails: "View Details",

        // tab component
        searchPlaceholder: "Search...",
        allColumns: "All columns",
        expand: "Expand",
        actions: "Actions",
        noData: "No data to display",
        edit: "Edit",
        delete: "Delete",
        details: "Details",

        confirmDeleteTitle: "Confirm deletion",
        confirmDeleteText: "Are you sure you want to delete user {{name}} ?",
        deleteConfirm: "Yes, delete",
        cancel: "Cancel",
        userDeletedSuccess: "User deleted successfully",
        userAddedSuccess: "User added successfully",
        userUpdatedSuccess: "User updated successfully",

        leaveBlankPassword: "Leave blank to keep current password",
        save: "Save",
        close: "Close",

        // User modal
        userDetails: "User Details",
        enterName: "Enter name",
        enterEmail: "Enter email",
        enterPassword: "Enter password",
        enterDepartment: "Enter department",
        confirmPasswordPlaceholder: "Confirm password",
        optional: "optional",
        nameRequired: "Name is required",
        emailRequired: "Email is required",

        // Roles
        user: "User",
        manager: "Manager",
        admin: "Administrator",

        // Bookings Page
        bookingsManagement: "Bookings Management",
        totalBookings: "Total Bookings",
        allTimeBookings: "All time bookings",
        confirmedBookings: "Confirmed Bookings",
        confirmedThisMonth: "Confirmed this month",
        totalRevenue: "Total revenue",
        cancelledBookings: "Cancelled Bookings",
        cancelledThisMonth: "Cancelled this month",

        // Filters
        allServices: "All services",
        allStatus: "All status",
        confirmed: "Confirmed",
        cancelled: "Cancelled",
        cancelled_at: "Cancelled at",

        // Table columns
        bookingNumber: "Booking Number",
        service: "Service",
        checkout: 'Check-out',
        provider: "Provider",
        totalAmount: "Total Amount",
        paymentStatus: "Payment",

        // Detail page
        bookingDetails: "Booking Details",
        bookingInformation: "Booking Information",
        passengers: "Passengers",
        holder: "Holder",
        years: "years",
        cancellationPolicies: "Cancellation Policies",
        amount: "Amount",


        bookingTimeline: 'Booking Timeline',
        flightDetails: 'Flight Details',
        passengerInformation: 'Passenger Information',
        clientAndProvider: 'Client & Provider',
        generalConditions: 'General Conditions',

        bookingCreated: 'Booking created',
        bookingConfirmed: 'Booking confirmed',
        bookingCancelled: 'Booking cancelled',
        paymentDeadline: 'Payment deadline',

        itinerary: 'Itinerary',
        duration: 'Duration',
        class: 'Class',
        officeID: 'Office ID',
        fareType: 'Fare Type',
        gdsFare: 'GDS',

        adults: 'Adults',
        passenger: 'passenger',
        birthDate: 'Birth date',
        passport: 'Passport',
        passportNumber: 'Passport number',
        expiryDate: 'Expiry date',

        client: 'Client',
        accountID: 'Account ID',

        destination: 'Destination',
        expiresOn: 'Expires on',

        viewVoucher: 'View Voucher',
        downloadVoucher: 'Download Voucher',
        markAsPaid: 'Mark as paid',

        termsAndConditionsDescription: 'The general terms and conditions apply to this booking. Check specific details in your booking confirmation.',

        loading: 'Loading...',
        bookingNotFound: 'Booking not found',
        backToBookings: 'Back to Bookings',
        booking: 'Booking',
        providerAmount: 'Provider amount',
        serviceFee: 'Service fee',
        serviceType: 'Service type',
        checkin: 'Check-in',
        refundable: 'Refundable',
        cancellationDeadline: 'Cancellation deadline',
        visible: 'Visible',
        emailSent: 'Email sent',
        invoiced: 'Invoiced',
        yes: 'Yes',
        no: 'No',
        hotelName: 'Hotel name',
        hotelCode: 'Hotel code',
        confirmationNumber: 'Confirmation number',
        rooms: 'Rooms',
        boardType: 'Board type',
        children: 'Children',
        price: 'Price',
        activityDetails: 'Activity Details',
        title: 'Title',
        meetingPoint: 'Meeting point',
        dropoffPoint: 'Dropoff point',
        hours: 'hours',
        mealIncluded: 'Meal included',
        guideLanguage: 'Guide language',
        schedules: 'Schedules',
        day: 'Day',
        startTime: 'Start time',
        endTime: 'End time',
        additionalInfo: 'Additional info',
        specialInstructions: 'Special instructions',
        viewTicket: 'View ticket',
        exportDetails: 'Export details',
        printItinerary: 'Print itinerary',
        passengerSummary: 'Passenger summary',
        infants: 'Infants',
        officeInformation: 'Office information',
        officeCode: 'Office code',
        airline: 'Airline',
        tripType: 'Trip type',
        oneWay: 'One way',
        roundTrip: 'Round trip',
        flightItineraries: 'Flight Itineraries',
        departure: 'Departure',
        arrival: 'Arrival',
        departureAirport: 'Departure airport',
        arrivalAirport: 'Arrival airport',
        noFlightItineraries: 'No flight itineraries available',
        additionalRemarks: 'Additional remarks',
        nationality: 'Nationality',
        passportCountry: 'Passport country',
        passportExpiry: 'Passport expiry',
        clientInfoNotAvailable: 'Client information not available',
        cancellationPolicy: 'Cancellation policy',
        fromDate: 'From',
        forAmount: 'for',
        notIncluded: 'Not included',
        Included: 'Included',
        extras: 'Extras',

        //supplier
        suppliersManagement: 'Suppliers Management',
        totalSuppliers: 'Total Suppliers',
        allSuppliers: 'All Suppliers',
        enabledSuppliers: 'Active Suppliers',
        newSuppliers: 'New Suppliers',
        pendingSuppliers: 'Pending',

        operatingCountries: 'Operating Countries',

        // Navigation
        backToSuppliers: 'Back to suppliers',
        supplierDetails: 'Supplier details',

        // Sections
        supplierInformation: 'Supplier information',
        associatedAccounts: 'Associated accounts',
                associatedProvider: 'Associated supplier',
        noAssociatedProvider: 'No Associated supplier',
        invoices: 'Invoices',

        // Informations du fournisseur
        address: 'Address',
        city: 'City',
        creationDate: 'Creation date',
        website: 'Website',

        // États du fournisseur
        enabled: 'Active',
        new: 'New',
        disabled: 'Disabled',

        // Boutons d'état
        activate: 'Activate',
        deactivate: 'Deactivate',
        reactivate: 'Reactivate',

        // Comptes associés
        administrator: 'Administrator',
        noAssociatedAccounts: 'No associated accounts',

        // Factures
        addInvoice: 'Add invoice',
        export: 'Export',
        invoiceNumber: 'Number',
        dueDate: 'Due date',
        amountExclTax: 'Amount excl. tax',
        currency: 'Currency',
        year: 'Year',

        // Résumé des factures
        totalInvoices: 'Number of invoices',
        paidInvoices: 'Paid',
        pendingInvoices: 'Pending',
        overdueInvoices: 'Overdue',
        noInvoices: 'No invoices',

        // Messages
        supplierStatusUpdated: 'Supplier status updated',

        // Services Management
        servicesManagement: 'Products Management',

        // Filters
        allTypes: 'All types',
        clearFilters: 'Clear filters',
        applyFilters: 'Apply filters',

        // Service types
        hotel: 'Hotel',
        activity: 'Activity',
        flight: 'Flight',
        transfer: 'Transfer',

        // Statuses
        draft: 'Draft',
        accepted: 'Accepted',
        rejected: 'Rejected',

        // Table columns
        product: 'Product',
        location: 'Location',
        activeStatus: 'Active Status',
        completion: 'Completion',

        //invoices
        overdue: 'Overdue',
        dueToday: 'Due today',
        dueSoon: 'Due soon',
        filterByStatus: 'Filter by status',
        filterByDate: 'Filter by date',
        showOverdue: 'Show overdue',
        invoicesList: 'Invoices list',

        //product details
        back: 'Back',
        productDetails: 'Product details',
        productNotFound: 'Product not found',
        generalInformation: 'General information',
        basicInfo: 'Basic information',
        description: 'Description',
        inclusionsExclusions: 'Inclusions / Exclusions',
        items: 'Items',
        quickActions: 'Quick actions',
        productName: 'Product name',
        bookingMode: 'Booking mode',
        dates: 'Dates',
        created: 'Created on',
        updated: 'Updated on',
        shortSummary: 'Short summary',
        fullDescription: 'Full description',
        viewSupplier: 'View supplier',
        viewClient: 'View client',
        viewBooking: 'View booking',
        capacity: 'Capacity',
        seniors: 'Seniors',
        guide: 'Guide',
        languages: 'Languages',
        audioGuide: 'Audio guide',
        options: 'Options',
        privateActivity: 'Private activity',
        dropoffLocation: 'Dropoff location',
        foodIncluded: 'Food included',
        transportIncluded: 'Transport included',
        published: 'Published',
        instant: 'Instant',
        included: 'Included',
        excluded: 'Excluded',
        requiredItems: 'Required items',
        prohibitedItems: 'Prohibited items',
        images: 'Images',
        noImages: 'No images available',
        noServiceViewAvailable: 'No service available',

        //hotel
        constructionYear: 'Construction year',
        lastRenovation: 'Last renovation',
        floors: 'Number of floors',
        pricingType: 'Pricing type',
        perRoom: 'per room',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        minCheckInAge: 'Minimum check-in age',
        amenitiesServices: 'Amenities & Services',
        roomTypes: 'Room Types',
        type: 'Type',
        configuration: 'Configuration',
        beds: 'Beds',
        none: 'None',
        recentRates: 'Recent Rates',
        meal: 'Meal',

        //hotel view
        transferDetails: 'Transfer Details',
        transferInformation: 'Transfer Information',
        transferType: 'Transfer type',
        availableVehicles: 'Available Vehicles',
        vehicle: 'vehicle',
        people: 'people',
        tariff: 'tariff',
        amenities: 'Amenities',

        //settings
        personalInformation: 'Personal Information',
        emailVerification: 'Email Verification',
        verified: 'Verified',
        notVerified: 'Not verified',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        accountSettings: 'Account Settings',
        securitySettings: 'Security',
        securitySettingsDescription: 'Manage your password and account security',
        profileSettings: 'Personal Information',
        profileSettingsDescription: 'Edit your profile and contact information',
        sessions: 'Sessions',
        activeSessionsDescription: 'View your login sessions',
        connexions: 'Connections',
        notProvided: 'Not provided',
        backToSettings: 'Back to settings',
        changePassword: 'Change password',
        currentPassword: 'Current password',
        enterCurrentPassword: 'Enter your current password',
        enterNewPassword: 'Enter your new password',
        confirmNewPassword: 'Confirm your new password',
        updating: 'Updating...',
        passwordRequirements: 'Password requirements',
        minCharacters: 'Minimum 8 characters',
        uppercaseLowercase: 'Uppercase and lowercase',
        includeNumbers: 'Include numbers',
        includeSpecialChars: 'Include special characters',

        //sub settings
        position: 'Position',
        editProfile: 'Edit profile',

    connectionHistory: 'Connection History',
    mostRecent: 'Most Recent',
    connectionDate: 'Connection Date',
    successfulConnection: 'Successful Connection',
    failedConnection: 'Failed Connection',
    unknownStatus: 'Unknown Status',
    noConnectionHistory: 'No Connection History',
    lastConnection: 'Last Connection',
    ipAddress: 'IP Address',
    dateAndTime: 'Date and Time',
    message: 'Message',

        securityInformation: 'Security information',
sessionsSecurityInfo1: "This page displays your recent connection history.",
sessionsSecurityInfo2: "Regularly check this history to detect any suspicious activity.",
sessionsSecurityInfo3: "If you notice unusual activity, immediately change your password and contact the security team.",

        //support 
        supportAdmin: 'Admin Support',
        supportSupplier: 'Supplier Support',
        closedTickets: 'Closed Tickets',
        allTickets: 'All Tickets',
        needsAttention: 'Need attention',
        resolvedTickets: 'Resolved Tickets',
        waitingResponse: 'Waiting for response',
        waitingCustomer: 'Waiting for customer',
        category: 'Category',
        assignedTo: 'Assigned to',
        open: 'Open',
        closed: 'Closed',
        customer: 'Customer',

        //exchange
        currentRate: 'Current rate',
        copiedToClipboard: 'Copied to clipboard',
        copyFailed: 'Copy failed',
        copyToClipboard: 'Copy result',
        exchangeRateDescription: 'Quickly convert your currencies with real-time exchange rates',
        enterAmount: 'Enter amount',
        calculate: 'Calculate',
        calculating: 'Calculating...',
        reset: 'Reset',
        conversionResult: 'Conversion result',
        invalidAmount: 'Please enter a valid amount',
        sameCurrency: 'Please select different currencies',
        exchangeRateUnavailable: 'Exchange rate unavailable',
        conversionSuccessful: 'Conversion successful',
        conversionError: 'Conversion error',
        saveChanges: 'Save changes',

        //stats
        navigation: 'Navigation',
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastQuarter: 'Last quarter',
        lastYear: 'Last year',
        responseTime: 'Response time',
        growth: 'Growth',

        //voucher
        voucher: 'Voucher',
        print: 'Print',
        download: 'Download',
        downloadPDF: 'Download PDF',
        loadError: 'Error loading',
        generatingPDF: 'Generating PDF...',
        pdfGenerated: 'PDF generated successfully',
        pdfError: 'Error generating PDF',
        unpaid: 'Unpaid',
        refused: 'Refused',
        expired: 'Expired',
        extranetVoucher: 'EXTRANET VOUCHER',
        bookingReference: 'Booking reference',
        productInformation: 'Product Information',
        providerInformation: 'Provider Information',
        flightInformation: 'Fight Information',
        importantNotes: 'Important Notes',
        checkinDate: 'Check-in date',
        checkoutDate: 'Check-out date',
        bookingDate: 'Booking date',
        productType: 'Product type',
        providerName: 'Provider name',
        contactEmail: 'Contact email',
        scanQRCode: 'Scan QR code for booking details',
        notePresentVoucher: 'Present this voucher to the service provider',
        noteKeepVoucher: 'Keep this voucher with you during your trip',
        noteEmergencyContact: 'In case of emergency, contact the provider directly',
        noteCancellationPolicies: 'Cancellation policies apply according to booking conditions',
        voucherGeneratedOn: 'Voucher generated on',
        officialVoucherMessage: 'This is an official travel voucher. Please keep it safe.',
        generatedBy: 'Generated by',
        notAvailable: 'N/A',

        noActivityDetails: 'No activity details available',
        priceRange: 'Price range',
        pricingDates: 'Pricing dates',
        babies: 'Babies',
        durationTiming: 'Duration and timing',
        cutoffTime: 'Cutoff time',
        arrivalTime: 'Arrival time',
        dateRange: 'Date range',
        guideInPerson: 'Guide in person',
        drinksIncluded: 'Drinks included',
        stopSales: 'Stop',
        allAvailable: 'All available',
        adult: 'Adult',
        child: 'Child',
        senior: 'Senior',
        baby: 'Baby',
        showingFirst: 'Showing first',
        of: 'of',
        minutes: 'minutes',
        notSpecified: 'Not specified',
        noPricing: 'No pricing',
        productId: 'Product ID',
        noServiceFee: 'No service fee',
        includedInPrice: 'Included in price',
        additionalFee: 'Additional fee',
        requirements: 'Requirements',
        keyPoints: 'Key points',
        '24HourPolicy': '24 hour policy',
        flexiblePolicy: 'Flexible policy',
        cancellationFee: 'Cancellation fee',
        freeCancellation: 'Free cancellation',
        noSummary: 'No summary available',
        noDescription: 'No description available',
        viewBookings: 'View bookings',
        editProduct: 'Edit product',
        activityName: 'Activity name',
        activityType: 'Activity type',
        airlineCode: 'Airline code',
        segments: 'Segments',
        cabinClasses: 'Cabin classes',
        flightNumber: 'Flight number',
        aircraftType: 'Aircraft type',
        baggageAllowance: 'Baggage allowance',
        cabinBaggage: 'Cabin baggage',
        checkedBaggage: 'Checked baggage',
        additionalFees: 'Additional fees',
        checkinInfo: 'Check-in information',
        onlineCheckin: 'Online check-in',
        airportCheckin: 'Airport check-in',
        boardingTime: 'Boarding time',
        directFlight: 'Direct',
        connectingFlight: 'Connecting flight',
        stopovers: 'Stopovers',
        servicesIncluded: 'Services included',
        restrictions: 'Restrictions',
        economyClass: 'Economy Class',
        businessClass: 'Business Class',
        firstClass: 'First Class',
        premiumEconomy: 'Premium Economy',
        mealService: 'Meal service',
        entertainment: 'In-flight entertainment',
        wifi: 'In-flight WiFi',
        seatSelection: 'Seat selection',
        noPets: 'Pets not allowed (except assistance)',
        noSmoking: 'No smoking',
        liquidsLimit: 'Liquids limit 100ml in cabin',
        noFlightDetails: 'No flight details available',
        noHotelDetails: 'No hotel details available',
        restaurants: 'Restaurants',
        swimmingPools: 'Swimming pools',
        perPerson: 'Per person',
        mealAgeRequirement: 'Minimum meal age',
        checkinTime: 'Check-in time',
        checkoutTime: 'Check-out time',
        basicServices: 'Basic services',
        reception24h: '24-hour reception',
        virtualReception: 'Virtual reception',
        welcomeService: 'Welcome service',
        earlyArrival: 'Early arrival',
        lateArrival: 'Late arrival',
        internetConnection: 'Internet connection',
        welcomeProcedures: 'Welcome procedures',
        physicalCheckin: 'Physical check-in',
        virtualCheckin: 'Virtual check-in',
        internetServices: 'Internet services',
        wifiFree: 'Free Wi-Fi',
        wifiPaid: 'Paid Wi-Fi',
        parkingServices: 'Parking services',
        parkingFree: 'Free parking',
        parkingPaid: 'Paid parking',
        outdoorPool: 'Outdoor pool',
        indoorPool: 'Indoor pool',
        accessibility: 'Accessibility',
        accessibilityOption: 'Accessibility option',
        roomAmenities: 'Room amenities',
        roomAmenity: 'Room amenity',
        generalServices: 'General services',
        generalService: 'General service',
        sportsActivities: 'Sports activities',
        sport: 'Sport',
        equipment: 'Equipment',
        wellnessServices: 'Wellness services',
        wellnessService: 'Wellness service',
        businessServices: 'Business services',
        businessService: 'Business service',
        familyRomanticServices: 'Family services',
        familyService: 'Family service',
        natureEnvironment: 'Nature and Environment',
        natureService: 'Nature service',
        hotelDetails: 'Hotel details',
        detailedServices: 'Detailed services',
        sportService: 'Sport service',
        nights: 'Nights',
        roomsCount: 'Number of rooms',
        adultCount: 'Number of adults',
        childCount: 'Number of children',
        roomType: 'Room type',
        roomCount: 'Number of rooms',
        amountProvider: 'Provider amount',
        mealPlan: 'Meal plan',
        mealType: 'Meal type',

        holderInformation: 'Holder Information',
        male: 'Male',
        female: 'Female',
        countryOfResidence: 'Country of residence',
        passportExpiration: 'Passport expiration',
        voucherCustomizer: 'Voucher Customizer',
        undo: 'Undo',
        redo: 'Redo',
        exportPDF: 'Export PDF',
        saveConfiguration: 'Save configuration',
        voucherHeader: 'Voucher Header',
        qrCode: 'QR Code',
        footer: 'Footer',
        logoConfiguration: 'Logo Configuration',
        showLogo: 'Show Logo',
        uploadLogo: 'Upload Logo',
        removeLogo: 'Remove Logo',
        logoPreview: 'Logo Preview',
        logoPosition: 'Logo Position',
        logoSize: 'Logo Size',
        logoOpacity: 'Logo Opacity',
        companyLogo: 'Company Logo',

        // Positions
        topLeft: 'Top Left',
        topCenter: 'Top Center',
        topRight: 'Top Right',
        bottomLeft: 'Bottom Left',
        bottomCenter: 'Bottom Center',
        bottomRight: 'Bottom Right',
        diagonal: 'Diagonal',
        repeat: 'Repeat',
        corner: 'Corner',

        // Sizes
        small: 'Small',
        medium: 'Medium',
        large: 'Large',

        // Watermark
        watermarkConfiguration: 'Watermark Configuration',
        showWatermark: 'Show Watermark',
        watermarkType: 'Watermark Type',
        textWatermark: 'Text Watermark',
        imageWatermark: 'Image Watermark',
        watermarkText: 'Watermark Text',
        enterWatermarkText: 'Enter watermark text...',
        uploadWatermarkImage: 'Upload Watermark Image',
        removeWatermark: 'Remove Watermark',
        watermarkPreview: 'Watermark Preview',
        watermarkPosition: 'Watermark Position',
        watermarkOpacity: 'Watermark Opacity',
        watermarkRotation: 'Watermark Rotation',
        watermarkSize: 'Watermark Size',
        watermark: 'Watermark',

        // Messages
        fileTooLarge: 'File is too large',
        logoUploaded: 'Logo uploaded successfully',
        watermarkUploaded: 'Watermark uploaded successfully',
        logoRemoved: 'Logo removed',
        watermarkRemoved: 'Watermark removed',

        customQrCode: 'Custom QR Code',
        useCustomQrCode: 'Use custom QR code',
        uploadQrCodeImage: 'Upload QR code image',
        removeQrCode: 'Remove QR code',
        qrCodePreview: 'QR code preview',
        qrCodeSize: 'QR code size',
        qrCodeBorderRadius: 'QR code border radius',
        showShadow: 'Show shadow',
        qrCodeMessage: 'Message under QR code',
        enterQrMessage: 'Enter message to display...',
        uploadCenterLogo: 'Center logo on QR code',
        qrCodePlaceholder: 'QR Code\n(Upload your own QR code)',
        encodedInformation: 'Encoded information',
        qrCodeInstructions: 'QR code instructions',
        qrInstruction1: 'Generate your QR code with an online service',
        qrInstruction2: 'Make sure it is good quality (300x300px min)',
        qrInstruction3: 'QR code should contain booking information',
        qrInstruction4: 'Supported format: PNG, JPG, SVG',
        uploaded: 'Uploaded',

        noSectionsAdded: 'No sections added. Use the left panel to add sections to the voucher.',
        customize: 'Customize',
        customizeVoucher: 'Customize voucher',
        sections: 'Sections',
        dragToReorder: 'Drag to reorder',
        layoutConfigTitle: 'Layout Configuration',
        layoutTypeLabel: 'Layout type',
        layoutVertical: 'Vertical',
        layoutGrid: 'Grid',
        columnCountLabel: 'Number of columns',
        resetLayoutButton: 'Reset layout',
        appearanceTitle: 'Appearance',
        primaryColorLabel: 'Primary color',
        backgroundColorLabel: 'Background color',
        fontSizeLabel: 'Font size',
        fontSizeSmall: 'Small',
        fontSizeLarge: 'Large',
        spacingLabel: 'Spacing',
        borderRadiusLabel: 'Border radius',
        fontFamilyLabel: 'Font family',
        fontPreview: 'Font preview',

        chooseFile: 'Choose file',
        headerLogo: 'Header logo',
        footerLogo: 'Footer logo',
        customLogo: 'Custom logo',
        left: 'Left',
        center: 'Center',
        right: 'Right',
        opacity: 'Opacity',

        headerLogoSettings: 'Header settings',
        footerLogoSettings: 'Footer settings',
        customLogoSettings: 'Custom logo settings',
        positionLabel: 'Position',
        sizeLabel: 'Size',

        currencies: "Currencies",
        differentCurrencies: "Different currencies",

        nonRefundable: 'Non refundable',
        editVoucher: 'Edit Voucher',
        bookingHistory: 'Booking History',
        paymentInformation: 'Payment Information',
        residenceCountry: 'Country of Residence',
        noConditions: 'No Conditions',
        chargeService: 'Service Fee',
        providerInfoNotAvailable: 'Provider information not available',
        customerAccount: 'Customer Account',
        providerPaymentStatus: 'Provider payment status',
        chargeServiceType: 'Service fee type',
        totalPassengers: 'Total passengers',

        room: 'Room',
        providerType: 'Provider type',
        hotelInformation: 'Hotel Information',

                country: 'Country',
        occupants: 'Occupants',
        roomDetails: 'Room Details',
        servicesInclusionsExclusions: 'Services Details',
        guestInformation: 'Guests Information',
        hotelVoucher: 'HOTEL VOUCHER',
        flightVoucher: 'FLIGHT VOUCHER',
        transferVoucher: 'TRANSFER VOUCHER',
        activityVoucher: 'ACTIVITY VOUCHER',
        padding:'Padding',

            cancellationNotes: 'Cancellation Notes',
    enableCancellationNotes: 'Enable cancellation notes',
    customCancellationPolicy: 'Custom cancellation policy',
    enterCustomPolicy: 'Enter your custom cancellation policy...',
    cancellationNotesList: 'Cancellation notes',
    noCancellationNotes: 'No cancellation notes added',
    addNewNote: 'Add new note',
    enterNoteText: 'Enter note text...',
    predefinedNotes: 'Predefined notes',
    nonRefundableAfter24h: 'Non-refundable 24h after booking',
    freeCancellationBefore48h: 'Free cancellation up to 48h before',
    partialRefund70percent: 'Partial refund of 70% before 7 days',
    administrativeFees50: 'Administrative fees of €50 for any cancellation',
    showSystemCancellationInfo: 'Show system information',
    confirmRemoveAllNotes: 'Remove all notes?',
    removeAllNotes: 'Remove all notes',
    removeNote: 'Remove note',
    add: 'Add',

        notesCustomization: 'Notes Customization',
    showNotesCustomization: 'Show notes customization',
    notesList: 'Notes list',
    emergencyContact: 'Emergency contact',
    enterEmergencyContact: 'Enter emergency contact...',
    showGenerationDate: 'Show generation date',
    resetToDefaultNotes: 'Reset to default notes',
    confirmResetToDefault: 'Reset to default notes?',
        officialRate: 'Official Rate',
    parallelRate: 'Parallel Rate',
    manageRates: 'Manage Rates',
    manageParallelRates: 'Manage Parallel Exchange Rates',
    usingParallelRates: 'Using custom parallel exchange rates',
    saveRate: 'Save Rate',
    savedRates: 'Saved Rates',
    noSavedRates: 'No custom rates saved',
    remove: 'Remove',
    invalidRate: 'Please enter a valid rate',
    rateUpdated: 'Rate updated successfully',
    rateReset: 'Rate reset to official value',
    to: 'To',

        manageExchangeRates: 'Manage Exchange Rates',
    loadingRates: 'Loading exchange rates',
    errorLoadingRates: 'Error loading exchange rates',
    rateSaved: 'Exchange rate saved successfully',
    saveError: 'Error saving rate',
    rateDeleted: 'Exchange rate deleted',
    deleteError: 'Error deleting rate',
    saving: 'Saving',
    noRatesSaved: 'No exchange rates saved',

        officialRates: 'Official Rates',
    parallelRates: 'Parallel Rates',
    manageAllRates: 'Manage All Exchange Rates',
    addNewRate: 'Add New Rate',
    addRate: 'Add Rate',
    noRatesAvailable: 'No rates available',
    confirmDelete: 'Are you sure you want to delete this exchange rate?',

        errorLoadingCountries: 'Error loading countries list',
    errorLoadingProviders: 'Error loading providers list',
    salesStatus: 'Sales Status',
    averageRevenue: 'Average Revenue',
    cancellationRate: 'Cancellation Rate',
    confirmedAndCancelled: 'Confirmed & Cancelled',
    perBooking: 'Per Booking',
    ofTotalBookings: 'Of Total Bookings',
    filters: 'Filters',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    allProviders: 'All Providers',
    allCountries: 'All Countries',
    resetFilters: 'Reset Filters',
    loadingData: 'Loading data',
    noDataDescription: 'No sales data found for the selected filters.',
    exportingData: 'Exporting data...',
    package: 'Package',
    partial: 'Partial',

        salesDetails: 'Sales Details',
    allBookings: 'All bookings',
    uniqueServices: 'Services',
    differentServiceTypes: 'Different service types',
    uniqueProviders: 'Providers',
    ofTotal: 'of total',
    revenueDetails: 'Revenue Details',
    averagePerBooking: 'Average per booking',
    dataGeneratedOn: 'Data generated on',
    providerRevenue: 'Provider Revenue',

        exportExcel: 'Export to Excel (.xlsx)',
    exportCSV: 'Export to CSV (.csv)',
    exportSuccess: 'Excel file exported successfully!',
    exportCSVSuccess: 'CSV file exported successfully!',
    exportError: 'Error exporting data',
    noDataToExport: 'No data to export',
    filtersApplied: 'Filters Applied',
    salesData: 'Sales Data',
    dateGenerated: 'Date Generated',
    unique: 'Unique',

        exportToExcel: 'Export to Excel',
    totalBookingsDesc: 'Total number of bookings made.',
    confirmedBookingsDesc: 'Number of bookings that have been confirmed.',
    cancelledBookingsDesc: 'Number of bookings that have been cancelled.',
    filterActive: 'Filter Active',

        cancelBooking: 'Cancel booking',
    cancelling: 'Cancelling...',
    confirmCancelBooking: 'Are you sure you want to cancel this booking?',
    enterCancelNote: 'Please enter a note explaining the reason for cancellation:',
    pleaseEnterCancelNote: 'Please enter a note for cancellation',
    bookingCancelledSuccess: 'Booking cancelled successfully',
    cancelBookingError: 'Error cancelling booking',
    allConditions: 'All conditions',
    loadingConditions: 'Loading conditions...',
    providerDeadline: 'Provider deadline',
    customerDeadline: 'Customer deadline',
    customerAmount: 'Customer amount',

        includedServices: 'Included services',
    excludedServices: 'Excluded services',
    generalPolicies: 'General policies',
    noIncludedServices: 'No included services',
    noExcludedServices: 'No excluded services',
    noCancellationPolicy: 'No cancellation policy',
    noGeneralPolicies: 'No general policies',
    existingConditions: 'Existing conditions',

        enterPhone: 'Enter phone number',
    phoneExample: 'Ex: +1 234 567 8900',
    enterWebsite: 'Enter website',
    enterAddress: 'Enter address',
    charges: 'Charges',
    chargesExample: 'Ex: Service fee 10%, Processing fee 5%',
    supplierUpdatedSuccess: 'Supplier updated successfully',
    addSupplier: 'Add supplier',

        backToUsers: 'Back to users',
    userNotFound: 'User not found',
    userInformation: 'User information',
    lastActivity: 'Last activity',
    permissions: 'Permissions',
    registeredOn: 'Registered on',
    sessionLogs: 'Session logs',
    exportLogs: 'Export logs',
    totalSessions: 'Total sessions',
    successful: 'Successful',
    failed: 'Failed',
    last24Hours: 'Last 24 hours',
    dateTime: 'Date and time',
    noSessionLogs: 'No session logs',
    sessionLogsWillAppear: 'Session logs will appear here',
    success: 'Success',
    errorLoadingUser: 'Error loading user',
    userStatusUpdated: 'User status updated',
    resetPasswordFeature: 'Reset password feature',

        enabledUsers: 'Enabled Users',
    disabledUsers: 'Disabled Users',
    activeUsers: 'All the active users',
    inactiveUsers: 'All the Inactive users',
    editSupplier: 'Edit supplier',
    errors: 'Errors',
    addressRequired: 'Address required',
    supportService: 'Support service',

        loadingProfile: 'Loading profile...',
    errorFetchingProfile: 'Error fetching profile',
    errorUpdatingProfile: 'Error updating profile',
    updateRequestError: 'Error sending update request.',
    tokenEmailSent: 'An email containing a validation code has been sent to your email address. Please enter the code below.',
    enterValidationCode: 'Please enter the validation code.',
    profileUpdatedSuccess: 'Your profile has been updated successfully!',
    invalidValidationCode: 'Invalid validation code.',
    errorValidatingToken: 'Error validating token',
    validationErrorTryAgain: 'Validation error. Please try again.',
    unknownDate: 'Unknown date',
    validationRequired: 'Validation required',
    enterValidationCodeEmail: 'Enter the validation code sent to your email address:',
    tokenPlaceholder: 'Ex: ABC123',
    validating: 'Validating...',
    validated: 'Validated',
    validateCode: 'Validate code',

        currentPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    confirmPasswordRequired: 'Password confirmation is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordsDoNotMatch: 'Passwords do not match',
    errorUpdatingPassword: 'Error updating password',
    passwordUpdateError: 'Error updating password',
    tokenEmailSentPassword: 'An email containing a validation code has been sent to your email address. Please enter the code below to validate the password change.',
    passwordUpdatedSuccess: 'Your password has been updated successfully!',

        resetUserPassword: 'Reset user password',
    resetPasswordWarning: 'WARNING: This action will generate a new random password and send it by email to the user. The user will need to use this password for their next login.',
    enterUserId: 'Enter user ID',
    resetPasswordConfirm: 'Confirm reset',
    resetPasswordConfirmation: 'Are you sure you want to reset the user\'s password',
    resetPasswordInstructions: 'An email containing the new password will be sent to the user\'s email address.',
    confirmReset: 'Confirm reset',
    resetting: 'Resetting...',
    resetPasswordSuccess: 'A new password has been generated and sent by email to the user.',
    resetPasswordError: 'Error resetting password. Please check the user ID.',
    resetPasswordApiError: 'API error resetting password',

        itemsPerPage: 'Items per page',
    showing: 'Showing',
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last',
        totalCustomers: 'Total Customers',
    allPlatformCustomers: 'All platform customers',
    enabledCustomers: 'Enabled customers',
    activeCustomers: 'Active customers',
    disabledCustomers: 'Disabled customers',
    inactiveCustomers: 'Inactive customers',
    pendingCustomers: 'Pending customers',
    waitingCustomers: 'Waiting customers',
    customersManagement: 'Customers Management',
    deposit: 'Deposit',

        addCustomer: 'Add customer',
    editCustomer: 'Edit customer',
    basicInformation: 'Basic information',
    suspended: 'Suspended',
    addressInformation: 'Address information',
    postalCode: 'Postal code',
    postcode: 'Postcode',
    selectCountry: 'Select country',
    selectCity: 'Select city',
    enterPostalCode: 'Enter postal code',
    enterPostcode: 'Enter postcode',
    selectCountryFirst: 'Select country first',
    commissionAndPayment: 'Commission and payment',
    commissionHotel: 'Commission hotel',
    commissionFlight: 'Commission flight',
    commissionTransfer: 'Commission transfer',
    commissionActivity: 'Commission activity',
    balance: 'Balance',
    language: 'Language',
    features: 'Features',
    hasHotel: 'Has hotel',
    hasFlight: 'Has flight',
    hasTransfer: 'Has transfer',
    hasActivity: 'Has activity',
    hasBooking: 'Has booking',
    paymentOptions: 'Payment options',
    payWithCreditCard: 'Pay with credit card',
    payWithDeposit: 'Pay with deposit',
    confirmRefundableBooking: 'Confirm refundable booking',
    notes: 'Notes',
    enterNotes: 'Enter notes',
    customerUpdatedSuccessfully: 'Customer updated successfully',
    errorLoadingCities: 'Error loading cities',

        selectFeatures: 'Select features',
    selectPaymentOptions: 'Select payment options',
    commissionMaxError: 'Commission cannot exceed 100%',
    customers: 'Customers',

        commissions: 'Commissions',
    financialInformation: 'Financial Information',
    documents: 'Documents',
    docMandatory: 'Mandatory document',
    docIataAgreement: 'IATA Agreement',
    docTradeLicence: 'Trade Licence',
    noNotes: 'No notes',
    createdOn: 'Created on',
    userName: 'Username',
    superAdmin: 'Super admin',
    customerStatusUpdated: 'Customer status updated',
    errorUpdatingStatus: 'Error updating status',
    customerUpdatedSuccess: 'Customer updated successfully',
    errorLoadingCustomer: 'Error loading customer',

    customerInformation: 'Customer Information',
    backToCustomers: 'Back to customers',
    customerNotFound: 'Customer not found',
        outbound: 'Outbound',
    return: 'Return',
    addToCalendar: 'Add to Calendar',

        oneWayTransfer: 'One-Way Transfer',
    roundTripTransfer: 'Round-Trip Transfer',
    forFlight: 'For Flight',
    viewRoute: 'View Route',
    contactDriver: 'Contact Driver',
    passengerCapacity: 'Passenger Capacity',
    adultPassengers: 'Adult Passengers',
    childPassengers: 'Child Passengers',
    passengersTotal: 'Passengers Total',
    vehicleCapacity: 'Vehicle Capacity',
    seats: 'Seats',
    transferItinerary: 'Transfer Itinerary',
    updateTime: 'Update Time',
    airportTransfer: 'Airport Transfer',
    generalTransfer: 'General Transfer',
    pickup: 'Pickup',
    transferRoute: 'Transfer Route',
    dropoff: 'Dropoff',
    vehicleDetails: 'Vehicle Details',
    brand: 'Brand',
    model: 'Model',
    luggageCapacity: 'Luggage Capacity',
    bags: 'bags',
    persons: 'persons',
    schedule: 'Schedule',
    travelType: 'Travel Type',
    travelNumber: 'Travel Number',
    locations: 'Locations',
    origin: 'Origin',
    allCurrencies: 'All currencies',
        fees: 'Fees',
    providerFees: 'Provider fees',
    deadline: 'Deadline',
    fullName: 'Full name',

        flightTransfer: 'Flight Transfer',
    trainTransfer: 'Train Transfer',
    vehicleInformation: 'Vehicle Information',
    vehicleType: 'Vehicle Type',
    date: 'Date',

        contactInformation: 'Contact Information',
    productInfo: 'Product',
    customerService: 'Customer Service',
    contactNote: 'For any questions regarding your booking, please contact the appropriate service above.',

        activityInformation: 'Activity Information',
    contactPhone: 'Contact Phone',
    passengerBreakdown: 'Passenger Breakdown',
    durationAndPrice: 'Duration & Price',
    activityPrice: 'Activity Price',
    detailedPrices: 'Detailed Prices',
    priceItem: 'Price Item',
    noDetailedPrices: 'No detailed prices',

        totalPrice: 'Total Price',
    days: 'day(s)',
    totalParticipants: 'Total Participants',
    locationDetails: 'Location Details',
    coordinates: 'Coordinates',
    detailedPricing: 'Detailed Pricing',
    description: 'Description',
    priceIncludesAll: 'All services and fees are included in the total price',
    backToDetails: 'Back to Details',
    participantBreakdown: 'Participant Breakdown',

        activationEmailSent: 'Activation email sent',
            activationInitiated: 'Activation initiated',
    activationLinkSentToSupplier: 'Activation link sent to supplier',

        occupancy: 'Occupancy',
    pricePerNight: 'Price/night',
    nightlyPrices: 'Nightly prices',
    rateComments: 'Rate comments',
    exclusions: 'Exclusions',
    inclusions: 'Inclusions',
    viewAmenties: 'View amenities',

        occupancyAndMeal: 'Occupants & Meal',
    totalOccupants: 'Total occupants',
    providerPrice: 'Provider price',
    moreNights: 'more nights',

        stayPeriod: 'Stay Period',
    occupancyDetails: 'Occupancy Details',
    occupants: 'Occupants',
    additionalInformation: 'Additional Information',

        sectionColorLabel: 'Section color',
    textColorLabel: 'Text color',
    secondaryColorLabel: 'Secondary color',

        statusFilter: 'Status filter',
    invoiceNumberFilter: 'Invoice number filter',
    exportInformation: 'Export information',
    exportDate: 'Export date',
    paid_at: 'Paid at',
    createFirstInvoice: 'Create first invoice',

        addNewInvoice: 'Add new invoice',
    findBookings: 'Find bookings',
    searchFilters: 'Search filters',
    searchBookings: 'Search bookings',
    searching: 'Searching...',
    selectBookings: 'Select bookings',
    selected: 'selected',
    selectAll: 'Select all',
    bookings: 'Bookings',
    bookingsFound: 'booking(s) found',
    noBookingsFound: 'No bookings found',
    noBookingsAvailable: 'No bookings available',
    useFiltersAboveToFindBookings: 'Use the filters above to find bookings',
    invoiceNotesPlaceholder: 'Additional notes for the invoice...',
    selectedBookings: 'Selected bookings',
    vatAmount: 'VAT amount',
    totalWithTax: 'Total with tax',
    creating: 'Creating...',
    createInvoice: 'Create invoice',
    selectCustomer: 'Select customer',
    selectService: 'Select service',
    dateType: 'Date type',
    loadingBookings: 'Loading bookings',
    errorLoadingCustomers: 'Error loading customers',
    errorLoadingServices: 'Error loading services',
    errorLoadingBookings: 'Error loading bookings',
    errorCreatingInvoice: 'Error creating invoice',
    pleaseFillAllFilters: 'Please fill all filters',
    selectAtLeastOneBooking: 'Select at least one booking',
    invoiceNumberRequired: 'Invoice number is required',
    invoiceCreatedSuccess: 'Invoice created successfully!',
        invoiceDetails: 'Invoice details',

            allCustomers: 'All customers',
    invoiceCreated: 'Invoice created!',
    configureSearchFilters: 'Configure search filters',
    customersFound: 'customer(s) found',
    searchError: 'Search error',
    pleaseSelectDates: 'Please select dates',
    confirmInvoiceCreation: 'Confirm invoice creation',
    summary: 'Summary',
    dueDate: 'Due date',
    invoiceCreationConfirmation: 'The invoice will be created with the selected bookings.',
    selectDueDate: 'Please select a due date',
    confirm: 'Confirm',
    
            invoices: 'Invoices',
    customerInvoices: 'Customer Invoices',
    providerInvoices: 'Provider Invoices',
    noCustomerInvoices: 'No customer invoices found',
    noProviderInvoices: 'No provider invoices found',
    useFiltersOrAddInvoice: 'Use filters or add an invoice',
    useFiltersToFindInvoices: 'Use filters to find invoices',
    exportInProgress: 'Export in progress...',
    errorLoadingCustomerInvoices: 'Error loading customer invoices',
    errorLoadingProviderInvoices: 'Error loading provider invoices',
    period: 'Period',
    pendingAmount: 'Pending amount',
    needAttention: 'Need attention',
    totalByCurrency: 'Total by Currency',

        backToInvoices: 'Back to invoices',
    providerInvoice: 'Provider invoice',
    customerInvoice: 'Customer invoice',
    invoiceDetail: 'Invoice detail',
    paidDate: 'Paid date',
    invoiceID: 'Invoice ID',
    financialDetails: 'Financial details',
    invoicePaid: 'Invoice paid',
    invoiceUnpaid: 'Invoice unpaid',
    invoiceOverdue: 'Invoice overdue',
    paidOn: 'Paid on',
    dueOn: 'Due on',
    overdueSince: 'Overdue since',
    share: 'Share',
    duplicate: 'Duplicate',
    exportBookings: 'Export bookings',
    invoiceDates: 'Invoice dates',
    invoiceDate: 'Invoice date',

        exportBookingsSelection: 'Bookings selection for export',
    search: 'Search',
    searchBookingsPlaceholder: 'Search by number, holder or service...',
    section: 'Section',
    zipCode: 'Zip code',
    serviceName: 'Service name',
    rateId: 'Rate ID',
    bookingId: 'Booking ID',
    invoiceInfo: 'Invoice information',
    selected: 'Selected',
    deselectAll: 'Deselect all',
    exportSelected: 'Export selection',
    noBookingsSelected: 'No bookings selected',

    invoiceInformation: 'Invoice information',
company: 'Company',

    invoice: 'Invoice',
    summary: 'Summary',
    pending: 'Pending',
    serviceType: 'Type',
    checkinDate: 'Check-in date',
    checkoutDate: 'Check-out date',
    totalBookings: 'Total bookings',
    exportGeneratedOn: 'Export generated on',
    document: 'Document',
    exportType: 'Export type',
    exportPdfSuccess: 'PDF exported successfully',
    exportPdfError: 'Error exporting PDF',

    exportToPDF:'Export to PDF',

        // Months
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',

        // Days
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',

        // Time expressions
        minutesAgo: '{{count}} min ago',
        hoursAgo: '{{count}}h ago',
        daysAgo: '{{count}} day(s) ago',


        // pays 
        france: 'France',
        spain: 'Spain',
        germany: 'Germany',
        italy: 'Italy'

    },
    es: {
        dashboard: 'Tablero',
        management: 'Gestión',
        finance: 'Finanzas',
        support: 'Soporte',
        authentication: 'Autenticación',
        settings: 'Configuración',
        users: 'Usuarios',
        suppliers: 'Proveedores',
        exchangeRate: 'Tipo de Cambio',
        sales: 'Estado de Ventas',
        reservations: 'Reservas',
        products: 'Productos',
        promotions: 'Promociones',
        statistics: 'Estadísticas',
        adminSupport: 'Soporte Admin',
        supplierSupport: 'Soporte Proveedor',
        welcome: 'Bienvenido',
        overview: 'Resumen',
        logout: 'Cerrar Sesión',
        profile: 'Perfil',
        revenue: 'Ingresos',
        newUsers: 'Nuevos usuarios',
        activeSuppliers: 'Proveedores activos',
        productsInStock: 'Productos en stock',
        todaysRevenue: 'Ingresos de hoy',
        monthlyRevenue: 'Ingresos mensuales',
        unpaidInvoices: 'Facturas pendientes',
        conversionRate: 'Tasa de conversión',
        thisWeek: 'Esta semana',
        total: 'Total',
        available: 'Disponibles',
        thisMonth: 'Este mes',
        recentActivity: 'Actividad reciente',
        supportTickets: 'Tickets de Soporte',
        createdProduct: 'creó un nuevo producto',
        madeReservation: 'hizo una reserva',
        updatedPromotion: 'actualizó una promoción',
        addedSupplier: 'agregó un proveedor',
        pricing: 'Precios',
        supplier: 'Proveedor',
        generatedInvoice: 'generó una factura',
        paymentIssue: 'Problema de pago',
        productQuestion: 'Pregunta sobre producto',
        refundRequest: 'Solicitud de reembolso',
        adminInterfaceBug: 'Error en interfaz admin',
        urgent: 'Urgente',
        pending: 'Pendiente',
        resolved: 'Resuelto',
        high: 'Alta',
        low: 'Baja',
        globalStatistics: 'Estadísticas Globales',
        salesEvolution: 'Evolución de Ventas',
        id: 'ID',
        subject: 'Asunto',
        priority: 'Prioridad',
        time: 'Tiempo',
        enter: 'Entrar',
        searchSectionPlaceholder: 'Buscar una sección...',
        main: 'Principal',
        keyMetrics: 'Métricas clave',
        totalProducts: 'Productos totales',
        pendingPayment: 'Pago pendiente',
        supportRequests: 'Solicitudes de soporte',
        salesByCountry: 'Ventas por país',
        other: 'Otros',
        topSellingProducts: 'Productos más vendidos',
        connectedUsers: 'Usuarios conectados',
        online: 'En línea',
        away: 'Ausente',
        trendingSearches: 'Búsquedas populares',
        searches: 'búsquedas',
        agenda: 'Agenda',
        participants: 'participantes',
        meeting: 'reunión',
        presentation: 'presentación',
        review: 'revisión',
        training: 'formación',
        teamMeeting: 'Reunión de equipo',
        clientPresentation: 'Presentación al cliente',
        productReview: 'Revisión de producto',
        trainingSession: 'Sesión de formación',
        deliveryProblem: 'Problema de entrega',
        technicalSupport: 'Soporte técnico',
        openTickets: 'Tickets abiertos',


        // Tradcción de connexion
        login: "Iniciar sesión",
        forgotPassword: "Contraseña olvidada",
        email: "E-mail",
        password: "Contraseña",
        rememberMe: "Recuérdame",
        loginButton: "Iniciar sesión",
        noAccount: "¿No tienes cuenta?",
        signUp: "Registrarse",
        forgotPasswordLink: "¿Olvidaste tu contraseña?",
        backToLogin: "Volver al inicio de sesión",
        resetPassword: "Restablecer contraseña",
        sendResetLink: "Enviar enlace",
        resetEmailSent: "Se ha enviado un correo de restablecimiento",
        newPassword: "Nueva contraseña",
        confirmPassword: "Confirmar contraseña",
        updatePassword: "Actualizar contraseña",
        passwordUpdated: "Contraseña actualizada con éxito",
        emailPlaceholder: "tu@email.com",
        passwordPlaceholder: "Ingresa tu contraseña",
        emailRequired: "El correo electrónico es obligatorio",
        passwordRequired: "La contraseña es obligatoria",
        invalidEmail: "Correo electrónico inválido",
        passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        passwordsDontMatch: "Las contraseñas no coinciden",
        loginError: "Correo electrónico o contraseña incorrectos",
        resetPasswordTitle: "Restablecer tu contraseña",
        resetPasswordDesc: "Ingresa tu correo para recibir un enlace de restablecimiento",
        updatePasswordTitle: "Crear nueva contraseña",
        updatePasswordDesc: "Ingresa tu nueva contraseña",
        passwordUpdateSuccess: "Su contraseña ha sido actualizada con éxito. Ahora puede iniciar sesión con su nueva contraseña.",

        //Tableau
        // Página de Usuarios
        usersManagement: "Gestión de Usuarios",
        addUser: "Agregar Usuario",

        // Tarjetas de estadísticas
        totalUsers: "Usuarios Totales",
        allPlatformUsers: "Todos los usuarios de la plataforma",
        currentlyOnline: "Actualmente en línea",
        administrators: "Administradores",
        usersWithAdminRights: "Usuarios con derechos de admin",
        otherUsers: "Otros Usuarios",
        standardUsers: "Usuarios estándar",

        // Columnas de la tabla
        name: "Nombre",
        role: "Rol",
        lastLogin: "Último acceso",
        department: "Departamento",
        phone: "Teléfono",

        // Acciones y mensajes
        confirmDeleteUser: "¿Está seguro de que desea eliminar este usuario?",
        editUser: "Editar Usuario",
        deleteUser: "Eliminar Usuario",
        viewDetails: "Ver Detalles",

        searchPlaceholder: "Buscar...",
        allColumns: "Todas las columnas",
        expand: "Expandir",
        actions: "Acciones",
        noData: "No hay datos para mostrar",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",

        confirmDeleteTitle: "Confirmar eliminación",
        confirmDeleteText: "¿Está seguro de que desea eliminar al usuario {{name}} ?",
        deleteConfirm: "Sí, eliminar",
        cancel: "Cancelar",
        userDeletedSuccess: "Usuario eliminado con éxito",
        userAddedSuccess: "Usuario agregado con éxito",
        userUpdatedSuccess: "Usuario actualizado con éxito",

        leaveBlankPassword: "Dejar en blanco para mantener la contraseña actual",
        save: "Guardar",
        close: "Cerrar",

        // Modal de usuario
        userDetails: "Detalles del Usuario",
        enterName: "Ingrese el nombre",
        enterEmail: "Ingrese el correo",
        enterPassword: "Ingrese la contraseña",
        enterDepartment: "Ingrese el departamento",
        confirmPasswordPlaceholder: "Confirme la contraseña",
        optional: "opcional",
        nameRequired: "El nombre es obligatorio",

        // Roles
        user: "Usuario",
        manager: "Gerente",
        admin: "Administrador",

        // Página Reservas
        bookingsManagement: "Gestión de Reservas",
        totalBookings: "Reservas Totales",
        allTimeBookings: "Desde el inicio",
        confirmedBookings: "Reservas Confirmadas",
        confirmedThisMonth: "Confirmadas este mes",
        totalRevenue: "Ingresos totales",
        cancelledBookings: "Reservas Canceladas",
        cancelledThisMonth: "Canceladas este mes",

        // Filtros
        allServices: "Todos los servicios",
        allStatus: "Todos los estados",
        confirmed: "Confirmado",
        cancelled: "Cancelado",
        cancelled_at: "Cancelado el",

        // Columnas tabla
        bookingNumber: "N° de Reserva",
        service: "Servicio",
        checkin: "Llegada",
        checkout: "Salida",
        provider: "Proveedor",
        status: "Estado",
        totalAmount: "Monto total",
        paymentStatus: "Pago",

        // Página detalle
        bookingDetails: "Detalles de la reserva",
        bookingInformation: "Información de la reserva",
        passengers: "Pasajeros",
        holder: "Titular",
        years: "años",
        cancellationPolicies: "Políticas de cancelación",
        amount: "Monto",

        bookingTimeline: 'Cronología de la reserva',
        flightDetails: 'Detalles del Vuelo',
        clientAndProvider: 'Cliente y Proveedor',
        generalConditions: 'Condiciones generales',

        bookingCreated: 'Reserva creada',
        bookingConfirmed: 'Reserva confirmada',
        bookingCancelled: 'Reserva cancelada',
        paymentDeadline: 'Fecha límite de pago',

        itinerary: 'Itinerario',
        duration: 'Duración',
        class: 'Clase',
        officeID: 'Office ID',
        fareType: 'Tipo de Tarifa',
        gdsFare: 'GDS',

        adults: 'Adultos',
        birthDate: 'Fecha de nacimiento',
        passport: 'Pasaporte',
        passportNumber: 'Número de pasaporte',
        expiryDate: 'Fecha de expiración',

        client: 'Cliente',
        accountID: 'ID de Cuenta',

        country: 'País',
        destination: 'Destino',
        expiresOn: 'Expira el',

        viewVoucher: 'Ver Cupón',
        downloadVoucher: 'Descargar Cupón',
        editVoucher: 'Editar Cupón',
        markAsPaid: 'Marcar como pagado',

        termsAndConditionsDescription: 'Las condiciones generales de venta se aplican a esta reserva. Consulte los detalles específicos en su confirmación de reserva.',

        loading: 'Cargando...',
        backToBookings: 'Volver a Reservas',
        booking: 'Reserva',
        providerAmount: 'Monto proveedor',
        serviceFee: 'Tarifa de servicio',
        serviceType: 'Tipo de servicio',
        refundable: 'Reembolsable',
        cancellationDeadline: 'Fecha límite de cancelación',
        visible: 'Visible',
        emailSent: 'Email enviado',
        invoiced: 'Facturado',
        hotelName: 'Nombre del hotel',
        hotelCode: 'Código del hotel',
        confirmationNumber: 'Número de confirmación',
        rooms: 'Habitaciones',
        boardType: 'Tipo de pensión',
        children: 'Niños',
        price: 'Precio',
        activityDetails: 'Detalles de la actividad',
        title: 'Título',
        meetingPoint: 'Punto de encuentro',
        dropoffPoint: 'Punto de entrega',
        hours: 'horas',
        mealIncluded: 'Comida incluida',
        guideLanguage: 'Idioma del guía',
        schedules: 'Horarios',
        day: 'Día',
        startTime: 'Hora de inicio',
        endTime: 'Hora de fin',
        additionalInfo: 'Información adicional',
        specialInstructions: 'Instrucciones especiales',
        viewTicket: 'Ver ticket',
        exportDetails: 'Exportar detalles',
        printItinerary: 'Imprimir itinerario',
        passengerSummary: 'Resumen de pasajeros',
        infants: 'Bebés',
        officeInformation: 'Información de la oficina',
        officeCode: 'Código de oficina',
        airline: 'Aerolínea',
        tripType: 'Tipo de viaje',
        oneWay: 'Solo ida',
        roundTrip: 'Ida y vuelta',
        flightItineraries: 'Itinerarios de Vuelo',
        departure: 'Salida',
        arrival: 'Llegada',
        departureAirport: 'Aeropuerto de salida',
        arrivalAirport: 'Aeropuerto de llegada',
        noFlightItineraries: 'No hay itinerarios de vuelo disponibles',
        additionalRemarks: 'Observaciones adicionales',
        nationality: 'Nacionalidad',
        passportCountry: 'País del pasaporte',
        passportExpiry: 'Vencimiento del pasaporte',
        clientInfoNotAvailable: 'Información del cliente no disponible',
        cancellationPolicy: 'Política de cancelación',
        forAmount: 'por',
        notIncluded: 'No incluido',
        Included: 'Incluido',
        extras: 'Extras',

        //proveedores
        suppliersManagement: 'Gestión de Proveedores',
        totalSuppliers: 'Total Proveedores',
        enabledSuppliers: 'Proveedores Activos',
        newSuppliers: 'Nuevos Proveedores',
        countries: 'Países',
        operatingCountries: 'Países de operación',

        // Navigation
        backToSuppliers: 'Volver a proveedores',
        supplierDetails: 'Detalles del proveedor',

        // Sections
        supplierInformation: 'Información del proveedor',
        associatedAccounts: 'Cuentas asociadas',
                        associatedProvider: 'Proveedores asociadas',
        noAssociatedProvider: 'Sin Asociadas Proveedores',
        invoices: 'Facturas',

        // Informations du fournisseur
        address: 'Dirección',
        city: 'Ciudad',
        creationDate: 'Fecha de creación',
        website: 'Sitio web',

        // États du fournisseur
        enabled: 'Activo',
        disabled: 'Desactivado',

        // Boutons d'état
        activate: 'Activar',
        deactivate: 'Desactivar',
        reactivate: 'Reactivar',

        // Comptes associés
        administrator: 'Administrador',
        noAssociatedAccounts: 'Sin cuentas asociadas',

        // Factures
        addInvoice: 'Agregar factura',
        export: 'Exportar',
        invoiceNumber: 'Número',
        dueDate: 'fecha límite',
        amountExclTax: 'Monto sin impuestos',
        currency: 'Moneda',
        year: 'Año',

        // Résumé des factures
        totalInvoices: 'Número de facturas',
        paidInvoices: 'Pagadas',
        pendingInvoices: 'Pendientes',
        overdueInvoices: 'Vencidas',
        noInvoices: 'Sin facturas',

        // Messages
        supplierStatusUpdated: 'Estado del proveedor actualizado',

        // Services Management
        servicesManagement: 'Gestión de Productos',

        // Filtros
        allTypes: 'Todos los tipos',
        clearFilters: 'Limpiar filtros',
        applyFilters: 'Aplicar filtros',

        // Tipos de servicios
        hotel: 'Hotel',
        activity: 'Actividad',
        flight: 'Vuelo',
        transfer: 'Transferencia',

        // Estados
        accepted: 'Aceptado',
        rejected: 'Rechazado',

        // Columnas de tabla
        product: 'Producto',
        location: 'Ubicación',
        activeStatus: 'Estado Activo',
        completion: 'Finalización',


        //invoices

        overdue: 'Vencidas',
        dueToday: 'Vence hoy',
        dueSoon: 'Vence pronto',
        filterByStatus: 'Filtrar por estado',
        filterByDate: 'Filtrar por fecha',
        showOverdue: 'Mostrar vencidas',
        invoicesList: 'Lista de facturas',

        //product details
        back: 'Volver',
        productDetails: 'Detalles del producto',
        productNotFound: 'Producto no encontrado',
        generalInformation: 'Información general',
        basicInfo: 'Información básica',
        description: 'Descripción',
        inclusionsExclusions: 'Incluido / No incluido',
        items: 'Elementos',
        quickActions: 'Acciones rápidas',
        productName: 'Nombre del producto',
        bookingMode: 'Modo de reserva',
        dates: 'Fechas',
        created: 'Creado el',
        updated: 'Actualizado el',
        shortSummary: 'Resumen corto',
        fullDescription: 'Descripción completa',
        viewSupplier: 'Ver proveedor',
        viewClient: 'Ver cliente',
        viewBooking: 'Ver reserva',
        capacity: 'Capacidad',
        seniors: 'Personas mayores',
        guide: 'Guía',
        languages: 'Idiomas',
        audioGuide: 'Guía de audio',
        options: 'Opciones',
        privateActivity: 'Actividad privada',
        dropoffLocation: 'Lugar de entrega',
        foodIncluded: 'Comida incluida',
        transportIncluded: 'Transporte incluido',
        published: 'Publicado',
        instant: 'Instantáneo',
        included: 'Incluido',
        excluded: 'No incluido',
        requiredItems: 'Elementos requeridos',
        prohibitedItems: 'Elementos prohibidos',
        images: 'Imágenes',
        noImages: 'No hay imágenes disponibles',
        noServiceViewAvailable: 'No servicio disponible',

        //hotel
        constructionYear: 'Año de construcción',
        lastRenovation: 'Última renovación',
        floors: 'Número de pisos',
        pricingType: 'Tipo de tarificación',
        perRoom: 'por habitación',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        minCheckInAge: 'Edad mínima para check-in',
        amenitiesServices: 'Servicios e Instalaciones',
        roomTypes: 'Tipos de Habitaciones',
        type: 'Tipo',
        configuration: 'Configuración',
        beds: 'Camas',
        none: 'Ninguna',
        recentRates: 'Tarifas Recientes',
        meal: 'Comida',

        //hotel view
        transferDetails: 'Detalles de la Transferencia',
        transferInformation: 'Información de la Transferencia',
        transferType: 'Tipo de transferencia',
        availableVehicles: 'Vehículos Disponibles',
        vehicle: 'vehículo',
        people: 'personas',
        tariff: 'tarifa',
        amenities: 'Equipamientos',


        //Settings
        personalInformation: 'Información Personal',
        emailVerification: 'Verificación de Email',
        verified: 'Verificado',
        notVerified: 'No verificado',
        createdAt: 'Creado el',
        updatedAt: 'Actualizado el',
        accountSettings: 'Configuración de la Cuenta',
        securitySettings: 'Seguridad',
        securitySettingsDescription: 'Gestiona tu contraseña y la seguridad de tu cuenta',
        profileSettings: 'Información Personal',
        profileSettingsDescription: 'Edita tu información de perfil y contacto',
        sessions: 'Sesiones',
        activeSessionsDescription: 'Ver tus sesiones de conexión',
                connexions: 'Conexiones',
        notProvided: 'No proporcionado',
        backToSettings: 'Volver a configuración',
        changePassword: 'Cambiar contraseña',
        currentPassword: 'Contraseña actual',
        enterCurrentPassword: 'Ingresa tu contraseña actual',
        enterNewPassword: 'Ingresa tu nueva contraseña',
        confirmNewPassword: 'Confirma tu nueva contraseña',
        updating: 'Actualizando...',
        passwordRequirements: 'Requisitos de contraseña',
        minCharacters: 'Mínimo 8 caracteres',
        uppercaseLowercase: 'Mayúsculas y minúsculas',
        includeNumbers: 'Incluir números',
        includeSpecialChars: 'Incluir caracteres especiales',

        //sub settings 
        position: 'Puesto',
        editProfile: 'Editar perfil',

    connectionHistory: 'Historial de Conexión',
    mostRecent: 'Más Reciente',
    connectionDate: 'Fecha de Conexión',
    successfulConnection: 'Conexión Exitosa',
    failedConnection: 'Conexión Fallida',
    unknownStatus: 'Estado Desconocido',
    noConnectionHistory: 'No hay Historial de Conexión',
    lastConnection: 'Última Conexión',
    ipAddress: 'Dirección IP',
    dateAndTime: 'Fecha y Hora',
    message: 'Mensaje',

        securityInformation: 'Información de seguridad',
sessionsSecurityInfo1: "Esta página muestra tu historial de conexiones recientes.",
sessionsSecurityInfo2: "Revisa regularmente este historial para detectar cualquier actividad sospechosa.",
sessionsSecurityInfo3: "Si notas actividad inusual, cambia inmediatamente tu contraseña y contacta al equipo de seguridad.",    

                //support
        supportAdmin: 'Soporte Admin',
        supportSupplier: 'Soporte Proveedor',
        totalTickets: 'Total Tickets',
        closedTickets: 'Tickets Cerrados',
        allTickets: 'Todos los tickets',
        needsAttention: 'Necesitan atención',
        resolvedTickets: 'Tickets resueltos',
        waitingResponse: 'En espera de respuesta',
        waitingCustomer: 'En espera del cliente',
        category: 'Categoría',
        assignedTo: 'Asignado a',
        open: 'Abierto',
        closed: 'Cerrado',
        customer: 'Cliente',

        //exchange
        currentRate: 'Tasa actual',
        copiedToClipboard: 'Copiado al portapapeles',
        copyFailed: 'Error al copiar',
        copyToClipboard: 'Copiar resultado',
        exchangeRateDescription: 'Convierte rápidamente tus divisas con tasas de cambio en tiempo real',
        enterAmount: 'Ingrese el monto',
        calculate: 'Calcular',
        calculating: 'Calculando...',
        reset: 'Reiniciar',
        conversionResult: 'Resultado de la conversión',
        invalidAmount: 'Por favor ingrese un monto válido',
        sameCurrency: 'Por favor seleccione divisas diferentes',
        exchangeRateUnavailable: 'Tasa de cambio no disponible',
        conversionSuccessful: 'Conversión exitosa',
        conversionError: 'Error en la conversión',
        saveChanges: 'Guardar cambios',

        //stats
        navigation: 'Navegación',
        lastWeek: 'Semana pasada',
        lastMonth: 'Mes pasado',
        lastQuarter: 'Trimestre pasado',
        lastYear: 'Año pasado',
        responseTime: 'Tiempo de respuesta',
        growth: 'Crecimiento',
        voucher: 'Cupón',
        print: 'Imprimir',
        download: 'Descargar',
        downloadPDF: 'Descargar PDF',
        loadError: 'Error al cargar',
        generatingPDF: 'Generando PDF...',
        pdfGenerated: 'PDF generado con éxito',
        pdfError: 'Error al generar PDF',
        unpaid: 'No pagado',
        refused: 'Rechazado',
        expired: 'Expirado',
        extranetVoucher: 'COUPÓN EXTRANET',
        bookingReference: 'Referencia de reserva',
        productInformation: 'Información del producto',
        providerInformation: 'Información del proveedor',
        passengerInformation: 'Información de Pasajeros',
        flightInformation: 'Información del Vuelo',
        importantNotes: 'Notas Importantes',
        checkinDate: 'Fecha de check-in',
        checkoutDate: 'Fecha de check-out',
        bookingDate: 'Fecha de reserva',
        productType: 'Tipo de producto',
        providerName: 'Nombre del proveedor',
        contactEmail: 'Email de contacto',
        scanQRCode: 'Escanea el código QR para detalles de la reserva',
        notePresentVoucher: 'Presente este cupón al proveedor de servicios',
        noteKeepVoucher: 'Mantenga este cupón con usted durante su viaje',
        noteEmergencyContact: 'En caso de emergencia, contacte directamente al proveedor',
        noteCancellationPolicies: 'Las políticas de cancelación se aplican según las condiciones de reserva',
        voucherGeneratedOn: 'Cupón generado el',
        officialVoucherMessage: 'Este es un cupón de viaje oficial. Por favor, consérvelo de forma segura.',
        generatedBy: 'Generado por',
        notAvailable: 'N/A',

        noActivityDetails: 'No hay detalles de actividad disponibles',
        priceRange: 'Rango de precios',
        pricingDates: 'Fechas con tarifas',
        babies: 'Bebés',
        durationTiming: 'Duración y horarios',
        cutoffTime: 'Tiempo límite',
        arrivalTime: 'Hora de llegada',
        dateRange: 'Período',
        guideInPerson: 'Guía en persona',
        drinksIncluded: 'Bebidas incluidas',
        stopSales: 'Stop',
        allAvailable: 'Todo disponible',
        adult: 'Adulto',
        child: 'Niño',
        senior: 'Adulto mayor',
        baby: 'Bebé',
        showingFirst: 'Mostrando primeros',
        of: 'de',
        minutes: 'minutos',
        notSpecified: 'No especificado',
        noPricing: 'Sin tarifas',
        productId: 'ID Producto',
        noServiceFee: 'Sin tarifa de servicio',
        includedInPrice: 'Incluido en el precio',
        additionalFee: 'Tarifa adicional',
        requirements: 'Requisitos',
        keyPoints: 'Puntos clave',
        '24HourPolicy': 'Política 24 horas',
        flexiblePolicy: 'Política flexible',
        cancellationFee: 'Tarifa de cancelación',
        freeCancellation: 'Cancelación gratuita',
        noSummary: 'No hay resumen disponible',
        noDescription: 'No hay descripción disponible',
        viewBookings: 'Ver reservas',
        editProduct: 'Editar producto',
        activityName: 'Nombre de la actividad',
        activityType: 'Tipo de actividad',
        airlineCode: 'Código aerolínea',
        segments: 'Segmentos',
        cabinClasses: 'Clases de cabina',
        flightNumber: 'Número de vuelo',
        aircraftType: 'Tipo de aeronave',
        baggageAllowance: 'Equipaje permitido',
        cabinBaggage: 'Equipaje de cabina',
        checkedBaggage: 'Equipaje facturado',
        additionalFees: 'Tarifas adicionales',
        checkinInfo: 'Información de check-in',
        onlineCheckin: 'Check-in en línea',
        airportCheckin: 'Check-in aeropuerto',
        boardingTime: 'Hora de embarque',
        directFlight: 'Directo',
        connectingFlight: 'Con conexión',
        stopovers: 'Escalas',
        servicesIncluded: 'Servicios incluidos',
        restrictions: 'Restricciones',
        economyClass: 'Clase Económica',
        businessClass: 'Clase Ejecutiva',
        firstClass: 'Primera Clase',
        premiumEconomy: 'Premium Económica',
        mealService: 'Servicio de comidas',
        entertainment: 'Entretenimiento a bordo',
        wifi: 'WiFi a bordo',
        seatSelection: 'Selección de asientos',
        noPets: 'Animales no permitidos (excepto asistencia)',
        noSmoking: 'Prohibido fumar',
        liquidsLimit: 'Límite líquidos 100ml en cabina',
        noFlightDetails: 'No hay detalles de vuelo disponibles',
        noHotelDetails: 'No hay detalles del hotel disponibles',
        restaurants: 'Restaurantes',
        swimmingPools: 'Piscinas',
        perPerson: 'Por persona',
        mealAgeRequirement: 'Edad mínima para comidas',
        checkinTime: 'Hora de llegada',
        checkoutTime: 'Hora de salida',
        basicServices: 'Servicios básicos',
        reception24h: 'Recepción 24 horas',
        virtualReception: 'Recepción virtual',
        welcomeService: 'Servicio de bienvenida',
        earlyArrival: 'Llegada anticipada',
        lateArrival: 'Llegada tardía',
        internetConnection: 'Conexión a Internet',
        welcomeProcedures: 'Procedimientos de bienvenida',
        physicalCheckin: 'Check-in físico',
        virtualCheckin: 'Check-in virtual',
        internetServices: 'Servicios de Internet',
        wifiFree: 'Wi-Fi gratuito',
        wifiPaid: 'Wi-Fi de pago',
        parkingServices: 'Servicios de aparcamiento',
        parkingFree: 'Aparcamiento gratuito',
        parkingPaid: 'Aparcamiento de pago',
        outdoorPool: 'Piscina exterior',
        indoorPool: 'Piscina interior',
        accessibility: 'Accesibilidad',
        accessibilityOption: 'Opción de accesibilidad',
        roomAmenities: 'Comodidades de la habitación',
        roomAmenity: 'Comodidad de habitación',
        generalServices: 'Servicios generales',
        generalService: 'Servicio general',
        sportsActivities: 'Actividades deportivas',
        sport: 'Deporte',
        equipment: 'Equipo',
        wellnessServices: 'Servicios de bienestar',
        wellnessService: 'Servicio de bienestar',
        businessServices: 'Servicios de negocios',
        businessService: 'Servicio de negocios',
        familyRomanticServices: 'Servicios familiares',
        familyService: 'Servicio familiar',
        natureEnvironment: 'Naturaleza y Medio Ambiente',
        natureService: 'Servicio de naturaleza',
        hotelDetails: 'Detalles del hotel',
        detailedServices: 'Servicios detallados',
        sportService: 'Servicio deportivo',

        nights: 'Noches',
        roomsCount: 'Número de habitaciones',
        adultCount: 'Número de adultos',
        childCount: 'Número de niños',
        roomType: 'Tipo de habitación',
        roomCount: 'Número de habitaciones',
        amountProvider: 'Monto proveedor',
        mealPlan: 'Tipo de pensión',
        mealType: 'Tipo de comida',

        holderInformation: 'Información del Titular',
        male: 'Hombre',
        female: 'Mujer',
        countryOfResidence: 'País de residencia',
        passportExpiration: 'Vencimiento del pasaporte',
        voucherCustomizer: 'Personalizador de cupón',
        undo: 'Deshacer',
        redo: 'Rehacer',
        exportPDF: 'Exportar PDF',
        saveConfiguration: 'Guardar configuración',

        // NOUVELLES TRADUCTIONS (sans doublons)
        logoConfiguration: 'Configuración del logo',
        showLogo: 'Mostrar logo',
        uploadLogo: 'Subir logo',
        removeLogo: 'Eliminar logo',
        logoPreview: 'Vista previa del logo',
        logoPosition: 'Posición del logo',
        logoSize: 'Tamaño del logo',
        logoOpacity: 'Opacidad del logo',
        companyLogo: 'Logo de la empresa',

        // Positions
        topLeft: 'Arriba izquierda',
        topCenter: 'Arriba centro',
        topRight: 'Arriba derecha',
        bottomLeft: 'Abajo izquierda',
        bottomCenter: 'Abajo centro',
        bottomRight: 'Abajo derecha',
        diagonal: 'Diagonal',
        repeat: 'Repetir',
        corner: 'Esquina',

        // Sizes
        small: 'Pequeño',
        medium: 'Mediano',
        large: 'Grande',

        // Watermark
        watermarkConfiguration: 'Configuración de marca de agua',
        showWatermark: 'Mostrar marca de agua',
        watermarkType: 'Tipo de marca de agua',
        textWatermark: 'Marca de agua de texto',
        imageWatermark: 'Marca de agua de imagen',
        watermarkText: 'Texto de marca de agua',
        enterWatermarkText: 'Ingrese texto de marca de agua...',
        uploadWatermarkImage: 'Subir imagen de marca de agua',
        removeWatermark: 'Eliminar marca de agua',
        watermarkPreview: 'Vista previa de marca de agua',
        watermarkPosition: 'Posición de marca de agua',
        watermarkOpacity: 'Opacidad de marca de agua',
        watermarkRotation: 'Rotación de marca de agua',
        watermarkSize: 'Tamaño de marca de agua',
        watermark: 'Marca de agua',

        // Messages
        fileTooLarge: 'El archivo es demasiado grande',
        logoUploaded: 'Logo subido exitosamente',
        watermarkUploaded: 'Marca de agua subida exitosamente',
        logoRemoved: 'Logo eliminado',
        watermarkRemoved: 'Marca de agua eliminada',
        voucherHeader: 'Encabezado del Cupón',
        qrCode: 'Código QR',
        footer: 'Pie de Página',

        customQrCode: 'Código QR Personalizado',
        useCustomQrCode: 'Usar código QR personalizado',
        uploadQrCodeImage: 'Subir imagen de código QR',
        removeQrCode: 'Eliminar código QR',
        qrCodePreview: 'Vista previa del código QR',
        qrCodeSize: 'Tamaño del código QR',
        qrCodeBorderRadius: 'Radio del borde del código QR',
        showShadow: 'Mostrar sombra',
        qrCodeMessage: 'Mensaje bajo el código QR',
        enterQrMessage: 'Ingrese mensaje a mostrar...',
        uploadCenterLogo: 'Logo en centro del código QR',
        qrCodePlaceholder: 'Código QR\n(Sube tu propio código QR)',
        encodedInformation: 'Información codificada',
        qrCodeInstructions: 'Instrucciones para el código QR',
        qrInstruction1: 'Genera tu código QR con un servicio en línea',
        qrInstruction2: 'Asegúrate de que sea de buena calidad (300x300px min)',
        qrInstruction3: 'El código QR debe contener información de reserva',
        qrInstruction4: 'Formato soportado: PNG, JPG, SVG',
        uploaded: 'Subido',

        noSectionsAdded: 'No se han añadido secciones. Utilice el panel izquierdo para añadir secciones al voucher.',
        customize: 'Personalizar',
        customizeVoucher: 'Personalizar voucher',
        sections: 'Secciones',
        dragToReorder: 'Arrastrar para reordenar',
        layoutConfigTitle: 'Configuración del diseño',
        layoutTypeLabel: 'Tipo de diseño',
        layoutVertical: 'Vertical',
        layoutGrid: 'Cuadrícula',
        columnCountLabel: 'Número de columnas',
        resetLayoutButton: 'Restablecer diseño',
        appearanceTitle: 'Apariencia',
        primaryColorLabel: 'Color primario',
        backgroundColorLabel: 'Color de fondo',
        fontSizeLabel: 'Tamaño de fuente',
        fontSizeSmall: 'Pequeño',
        fontSizeLarge: 'Grande',
        spacingLabel: 'Espaciado',
        borderRadiusLabel: 'Radio del borde',
        fontFamilyLabel: 'Familia de fuentes',
        fontPreview: 'Vista previa de fuente',

        chooseFile: 'Elegir archivo',
        headerLogo: 'Logo en encabezado',
        footerLogo: 'Logo en pie de página',
        customLogo: 'Logo personalizado',
        left: 'Izquierda',
        center: 'Centro',
        right: 'Derecha',
        opacity: 'Opacidad',
        headerLogoSettings: 'Configuración de cabecera',
        footerLogoSettings: 'Configuración de pie de página',
        customLogoSettings: 'Configuración de logo personalizado',
        positionLabel: 'Posición',
        sizeLabel: 'Tamaño',

        currencies: "Monedas",
        differentCurrencies: "Monedas diferentes",

        nonRefundable: 'No reembolsable',
        bookingHistory: 'Historial de reservas',
        paymentInformation: 'Información de pago',
        residenceCountry: 'País de residencia',
        noConditions: 'Sin condiciones',
        chargeService: 'Tarifa de servicio',
        providerInfoNotAvailable: 'Información del proveedor no disponible',
        customerAccount: 'Cuenta del cliente',
        providerPaymentStatus: 'Estado de pago del proveedor',
        chargeServiceType: 'Tipo de tarifa de servicio',
        totalPassengers: 'Total de pasajeros',

        room: 'Habitación',
        providerType: 'Tipo de proveedor',
        age: 'Edad',
        gender: 'Género',
        hotelInformation: 'Información Del Hotel',
        no: 'No',

        occupants: 'Ocupantes',
        roomDetails: 'Detalles de la habitación',
        servicesInclusionsExclusions: 'Detalles Servicios',
        guestInformation: 'Información Del Huésped',
        hotelVoucher: 'CUPÓN DEL HOTEL',
        flightVoucher: 'CUPÓN DEL VUELO',
        transferVoucher: 'CUPÓN DEL TRANSFER',
        activityVoucher: 'CUPÓN DEL ACTIVIDAD',
        padding: 'Relleno',

            cancellationNotes: 'Notas de Cancelación',
    enableCancellationNotes: 'Activar notas de cancelación',
    customCancellationPolicy: 'Política de cancelación personalizada',
    enterCustomPolicy: 'Ingrese su política de cancelación personalizada...',
    cancellationNotesList: 'Notas de cancelación',
    noCancellationNotes: 'No hay notas de cancelación añadidas',
    addNewNote: 'Añadir nueva nota',
    enterNoteText: 'Ingrese texto de la nota...',
    predefinedNotes: 'Notas predefinidas',
    nonRefundableAfter24h: 'No reembolsable 24h después de la reserva',
    freeCancellationBefore48h: 'Cancelación gratuita hasta 48h antes',
    partialRefund70percent: 'Reembolso parcial del 70% antes de 7 días',
    administrativeFees50: 'Gastos administrativos de €50 por cualquier cancelación',
    showSystemCancellationInfo: 'Mostrar información del sistema',
    confirmRemoveAllNotes: '¿Eliminar todas las notas?',
    removeAllNotes: 'Eliminar todas las notas',
    removeNote: 'Eliminar nota',
    add: 'Añadir',

        notesCustomization: 'Personalización de Notas',
    showNotesCustomization: 'Mostrar personalización de notas',
    notesList: 'Lista de notas',
    emergencyContact: 'Contacto de emergencia',
    enterEmergencyContact: 'Ingrese contacto de emergencia...',
    showGenerationDate: 'Mostrar fecha de generación',
    resetToDefaultNotes: 'Restablecer notas por defecto',
    confirmResetToDefault: '¿Restablecer notas por defecto?',
        officialRate: 'Tasa oficial',
    parallelRate: 'Tasa paralela',
    manageRates: 'Gestionar tasas',
    manageParallelRates: 'Gestionar tasas de cambio paralelas',
    usingParallelRates: 'Usando tasas de cambio paralelas personalizadas',
    saveRate: 'Guardar tasa',
    savedRates: 'Tasas guardadas',
    noSavedRates: 'No hay tasas personalizadas guardadas',
    remove: 'Eliminar',
    invalidRate: 'Por favor ingrese una tasa válida',
    rateUpdated: 'Tasa actualizada exitosamente',
    rateReset: 'Tasa restablecida al valor oficial',
    to: 'A',
        manageExchangeRates: 'Gestionar Tasas de Cambio',
    loadingRates: 'Cargando tasas de cambio',
    errorLoadingRates: 'Error al cargar tasas de cambio',
    rateSaved: 'Tasa de cambio guardada exitosamente',
    saveError: 'Error al guardar la tasa',
    rateDeleted: 'Tasa de cambio eliminada',
    deleteError: 'Error al eliminar la tasa',
    saving: 'Guardando',
    noRatesSaved: 'No hay tasas de cambio guardadas',

        officialRates: 'Tasas oficiales',
    parallelRates: 'Tasas paralelas',
    manageAllRates: 'Gestionar todas las tasas de cambio',
    addNewRate: 'Agregar nueva tasa',
    addRate: 'Agregar tasa',
    noRatesAvailable: 'No hay tasas disponibles',
    confirmDelete: '¿Está seguro de que desea eliminar esta tasa de cambio?',

        errorLoadingCountries: 'Error al cargar la lista de países',
    errorLoadingProviders: 'Error al cargar la lista de proveedores',
    salesStatus: 'Estado de ventas',
    averageRevenue: 'Ingreso promedio',
    cancellationRate: 'Tasa de cancelación',
    confirmedAndCancelled: 'Confirmadas y Canceladas',
    perBooking: 'Por reserva',
    ofTotalBookings: 'Del total de reservas',
    filters: 'Filtros',
    dateFrom: 'Fecha desde',
    dateTo: 'Fecha hasta',
    allProviders: 'Todos los proveedores',
    allCountries: 'Todos los países',
    resetFilters: 'Restablecer filtros',
    loadingData: 'Cargando datos',
    noDataDescription: 'No se encontraron datos de ventas para los filtros seleccionados.',
    exportingData: 'Exportando datos...',
    package: 'Paquete',
    partial: 'Parcial',

        salesDetails: 'Detalles de ventas',
    allBookings: 'Todas las reservas',
    uniqueServices: 'Servicios',
    differentServiceTypes: 'Diferentes tipos de servicios',
    uniqueProviders: 'Proveedores',
    ofTotal: 'del total',
    revenueDetails: 'Detalles de ingresos',
    averagePerBooking: 'Promedio por reserva',
    dataGeneratedOn: 'Datos generados el',
    providerRevenue: 'Ingresos del Proveedor',

        exportExcel: 'Exportar a Excel (.xlsx)',
    exportCSV: 'Exportar a CSV (.csv)',
    exportSuccess: '¡Archivo Excel exportado exitosamente!',
    exportCSVSuccess: '¡Archivo CSV exportado exitosamente!',
    exportError: 'Error al exportar datos',
    noDataToExport: 'No hay datos para exportar',
    filtersApplied: 'Filtros aplicados',
    salesData: 'Datos de ventas',
    dateGenerated: 'Fecha generada',
    unique: 'Único',

    exportToExcel: 'Exportar a Excel',
    totalBookingsDesc: 'Número total de reservas realizadas.',
    confirmedBookingsDesc: 'Número de reservas que han sido confirmadas.',
    cancelledBookingsDesc: 'Número de reservas que han sido canceladas.',
    bookingNotFound: 'Reserva no encontrada',
    filterActive: 'Filtro activo',

        cancelBooking: 'Cancelar reserva',
    cancelling: 'Cancelando...',
    confirmCancelBooking: '¿Está seguro de que desea cancelar esta reserva?',
    enterCancelNote: 'Por favor ingrese una nota explicando la razón de la cancelación:',
    pleaseEnterCancelNote: 'Por favor ingrese una nota para la cancelación',
    bookingCancelledSuccess: 'Reserva cancelada exitosamente',
    cancelBookingError: 'Error al cancelar la reserva',
    allConditions: 'Todas las condiciones',
    loadingConditions: 'Cargando condiciones...',
    providerDeadline: 'Fecha límite proveedor',
    customerDeadline: 'Fecha límite cliente',
    customerAmount: 'Monto cliente',

        includedServices: 'Servicios incluidos',
    excludedServices: 'Servicios excluidos',
    generalPolicies: 'Políticas generales',
    noIncludedServices: 'No hay servicios incluidos',
    noExcludedServices: 'No hay servicios excluidos',
    noCancellationPolicy: 'No hay política de cancelación',
    noGeneralPolicies: 'No hay políticas generales',
    existingConditions: 'Condiciones existentes',

        enterPhone: 'Ingrese número de teléfono',
    phoneExample: 'Ej: +34 912 345 678',
    enterWebsite: 'Ingrese sitio web',
    enterAddress: 'Ingrese dirección',
    charges: 'Cargos',
    chargesExample: 'Ej: Tarifa de servicio 10%, Tarifa de procesamiento 5%',
    supplierUpdatedSuccess: 'Proveedor actualizado exitosamente',
    addSupplier: 'Agregar proveedor',

       backToUsers: 'Volver a usuarios',
    userNotFound: 'Usuario no encontrado',
    userInformation: 'Información del usuario',
    lastActivity: 'Última actividad',
    permissions: 'Permisos',
    registeredOn: 'Registrado el',
    sessionLogs: 'Registros de sesión',
    exportLogs: 'Exportar registros',
    totalSessions: 'Sesiones totales',
    successful: 'Exitosa',
    failed: 'Fallida',
    last24Hours: 'Últimas 24 horas',
    dateTime: 'Fecha y hora',
    noSessionLogs: 'No hay registros de sesión',
    sessionLogsWillAppear: 'Los registros de sesión aparecerán aquí',
    success: 'Éxito',
    errorLoadingUser: 'Error al cargar el usuario',
    userStatusUpdated: 'Estado del usuario actualizado',
    errorUpdatingStatus: 'Error al actualizar el estado',
    resetPasswordFeature: 'Función de restablecimiento de contraseña',

        enabledUsers: 'Usuarios habilitados',
    disabledUsers: 'Usuarios deshabilitados',
    activeUsers: 'Todos los usuarios activos',
    inactiveUsers: 'Todos los usuarios inactivos',
    editSupplier: 'Editar proveedor',
    errors: 'Errores',
    addressRequired: 'Dirección requerida',
    supportService: 'Servicio de soporte',

        loadingProfile: 'Cargando perfil...',
    errorFetchingProfile: 'Error al recuperar el perfil',
    errorUpdatingProfile: 'Error al actualizar el perfil',
    updateRequestError: 'Error al enviar la solicitud de actualización.',
    tokenEmailSent: 'Se ha enviado un correo electrónico con un código de validación a su dirección de correo electrónico. Por favor ingrese el código a continuación.',
    enterValidationCode: 'Por favor ingrese el código de validación.',
    profileUpdatedSuccess: '¡Su perfil se ha actualizado exitosamente!',
    invalidValidationCode: 'Código de validación incorrecto.',
    errorValidatingToken: 'Error al validar el token',
    validationErrorTryAgain: 'Error de validación. Por favor intente nuevamente.',
    unknownDate: 'Fecha desconocida',
    validationRequired: 'Validación requerida',
    enterValidationCodeEmail: 'Ingrese el código de validación enviado a su dirección de correo electrónico:',
    tokenPlaceholder: 'Ej: ABC123',
    validating: 'Validando...',
    validated: 'Validado',
    validateCode: 'Validar código',

        currentPasswordRequired: 'La contraseña actual es requerida',
    newPasswordRequired: 'La nueva contraseña es requerida',
    confirmPasswordRequired: 'La confirmación de contraseña es requerida',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    errorUpdatingPassword: 'Error al actualizar la contraseña',
    passwordUpdateError: 'Error al actualizar la contraseña',
    tokenEmailSentPassword: 'Se ha enviado un correo electrónico con un código de validación a su dirección de correo electrónico. Por favor ingrese el código a continuación para validar el cambio de contraseña.',
    passwordUpdatedSuccess: '¡Su contraseña se ha actualizado exitosamente!',

        resetUserPassword: 'Restablecer contraseña de usuario',
    resetPasswordWarning: 'ADVERTENCIA: Esta acción generará una nueva contraseña aleatoria y la enviará por correo electrónico al usuario. El usuario necesitará usar esta contraseña para su próximo inicio de sesión.',
    enterUserId: 'Ingrese ID de usuario',
    resetPasswordConfirm: 'Confirmar restablecimiento',
    resetPasswordConfirmation: '¿Está seguro de que desea restablecer la contraseña del usuario',
    resetPasswordInstructions: 'Se enviará un correo electrónico con la nueva contraseña a la dirección de correo electrónico del usuario.',
    confirmReset: 'Confirmar restablecimiento',
    resetting: 'Restableciendo...',
    resetPasswordSuccess: 'Se ha generado una nueva contraseña y se ha enviado por correo electrónico al usuario.',
    resetPasswordError: 'Error al restablecer la contraseña. Por favor verifique el ID de usuario.',
    resetPasswordApiError: 'Error de API al restablecer la contraseña',


    // pagination
    itemsPerPage: 'Elementos por página',
    showing: 'Mostrando',
    first: 'Primero',
    previous: 'Anterior',
    next: 'Siguiente',
    last: 'Último',

        totalCustomers: 'Clientes totales',
    allPlatformCustomers: 'Todos los clientes de la plataforma',
    enabledCustomers: 'Clientes habilitados',
    activeCustomers: 'Clientes activos',
    disabledCustomers: 'Clientes deshabilitados',
    inactiveCustomers: 'Clientes inactivos',
    pendingCustomers: 'Clientes pendientes',
    waitingCustomers: 'Clientes en espera',
    customersManagement: 'Gestión de Clientes',
    deposit: 'Depósito',

        addCustomer: 'Agregar cliente',
    editCustomer: 'Editar cliente',
    basicInformation: 'Información básica',
    suspended: 'Suspendido',
    addressInformation: 'Información de dirección',
    postalCode: 'Código postal',
    postcode: 'Código postal',
    selectCountry: 'Seleccionar país',
    selectCity: 'Seleccionar ciudad',
    enterPostalCode: 'Ingrese código postal',
    enterPostcode: 'Ingrese código postal',
    selectCountryFirst: 'Seleccione país primero',
    commissionAndPayment: 'Comisión y pago',
    commissionHotel: 'Comisión hotel',
    commissionFlight: 'Comisión vuelo',
    commissionTransfer: 'Comisión transferencia',
    commissionActivity: 'Comisión actividad',
    balance: 'Saldo',
    language: 'Idioma',
    features: 'Características',
    hasHotel: 'Tiene hotel',
    hasFlight: 'Tiene vuelo',
    hasTransfer: 'Tiene transferencia',
    hasActivity: 'Tiene actividad',
    hasBooking: 'Tiene reserva',
    paymentOptions: 'Opciones de pago',
    payWithCreditCard: 'Pagar con tarjeta de crédito',
    payWithDeposit: 'Pagar con depósito',
    confirmRefundableBooking: 'Confirmar reserva reembolsable',
    notes: 'Notas',
    enterNotes: 'Ingrese notas',
    customerUpdatedSuccessfully: 'Cliente actualizado exitosamente',
    errorLoadingCities: 'Error al cargar ciudades',

        selectFeatures: 'Seleccionar características',
    selectPaymentOptions: 'Seleccionar opciones de pago',
    commissionMaxError: 'La comisión no puede exceder el 100%',
    customers: 'Clientes',

        commissions: 'Comisiones',
    financialInformation: 'Información financiera',
    documents: 'Documentos',
    docMandatory: 'Documento obligatorio',
    docIataAgreement: 'Acuerdo IATA',
    docTradeLicence: 'Licencia comercial',
    noNotes: 'Sin notas',
    createdOn: 'Creado el',
    userName: 'Nombre de usuario',
    superAdmin: 'Super administrador',
    customerStatusUpdated: 'Estado del cliente actualizado',
    customerUpdatedSuccess: 'Cliente actualizado exitosamente',
    errorLoadingCustomer: 'Error al cargar el cliente',

        customerInformation: 'Información del Cliente',
    backToCustomers: 'Volver a clientes',
    customerNotFound: 'Cliente no encontrado',

        outbound: 'Salida',
    return: 'Regreso',
    addToCalendar: 'Agregar al calendario',

        oneWayTransfer: 'Transfer Ida',
    roundTripTransfer: 'Transfer Ida y Vuelta',
    forFlight: 'Para Vuelo',
    viewRoute: 'Ver Ruta',
    contactDriver: 'Contactar Conductor',
    passengerCapacity: 'Capacidad de Pasajeros',
    adultPassengers: 'Pasajeros Adultos',
    childPassengers: 'Pasajeros Niños',
    passengersTotal: 'Total Pasajeros',
    vehicleCapacity: 'Capacidad del Vehículo',
    seats: 'Asientos',
    transferItinerary: 'Itinerario de Transfer',
    updateTime: 'Tiempo de Actualización',
    airportTransfer: 'Transfer Aeropuerto',
    generalTransfer: 'Transfer General',
    pickup: 'Recogida',
    transferRoute: 'Ruta de Transfer',
    dropoff: 'Dejada',
    vehicleDetails: 'Detalles del Vehículo',
    brand: 'Marca',
    model: 'Modelo',
    luggageCapacity: 'Capacidad de Equipaje',
    bags: 'maletas',
    persons: 'personas',
    schedule: 'Horario',
    travelType: 'Tipo de Viaje',
    travelNumber: 'Número de Viaje',
    locations: 'Ubicaciones',
    origin: 'Origen',
    allCurrencies: 'Todas las monedas',
        fees: 'Tarifas',
    providerFees: 'Tarifas proveedor',
    deadline: 'Fecha límite',
    fullName: 'Nombre completo',

        flightTransfer: 'Transfer para vuelo',
    trainTransfer: 'Transfer para tren',
    vehicleInformation: 'Información del vehículo',
    vehicleType: 'Tipo de vehículo',
    date: 'Fecha',

    contactInformation: 'Información de contacto',
    productInfo: 'Producto',
    customerService: 'Servicio al cliente',
    contactNote: 'Para cualquier pregunta sobre su reserva, por favor contacte el servicio apropiado arriba.',

            activityInformation: 'Información de Actividad',
    contactPhone: 'Teléfono de contacto',
    passengerBreakdown: 'Desglose de pasajeros',
    durationAndPrice: 'Duración y Precio',
    activityPrice: 'Precio de la actividad',
    detailedPrices: 'Precios detallados',
    priceItem: 'Artículo precio',
    noDetailedPrices: 'No precios detallados',

        totalPrice: 'Precio total',
    days: 'día(s)',
    totalParticipants: 'Total participantes',
    locationDetails: 'Detalles del lugar',
    coordinates: 'Coordenadas',
    detailedPricing: 'Tarificación detallada',
    description: 'Descripción',
    priceIncludesAll: 'Todos los servicios y tarifas están incluidos en el precio total',
    backToDetails: 'Volver a detalles',
    participantBreakdown: 'Desglose de participantes',

        activationEmailSent: 'Correo de activación enviado',
            activationInitiated: 'Activación iniciada',
    activationLinkSentToSupplier: 'Enlace de activación enviado al proveedor',

        occupancy: 'Ocupación',
    pricePerNight: 'Precio/noche',
    nightlyPrices: 'Precios nocturnos',
    rateComments: 'Comentarios de tarifas',
    exclusions: 'Exclusiones',
    inclusions: 'Inclusiones',
    viewAmenties: 'Ver equipamientos',

    occupancyAndMeal: 'Ocupantes & Comida',
    totalOccupants: 'Total ocupantes',
    providerPrice: 'Precio proveedor',
    moreNights: 'noches adicionales',

        stayPeriod: 'Período de estancia',
    occupancyDetails: 'Detalles de ocupación',
    occupants: 'Ocupantes',
    additionalInformation: 'Información adicional',

        sectionColorLabel: 'Color de sección',
    textColorLabel: 'Color del texto',
    secondaryColorLabel: 'Color secundario',

        statusFilter: 'Filtro por estado',
    invoiceNumberFilter: 'Filtro por número de factura',
    exportInformation: 'Información de exportación',
    exportDate: 'Fecha de exportación',
    paid_at: 'Pagado el',
    createFirstInvoice: 'Crear primera factura',

        addNewInvoice: 'Agregar nueva factura',
    findBookings: 'Encontrar reservas',
    searchFilters: 'Filtros de búsqueda',
    searchBookings: 'Buscar reservas',
    searching: 'Buscando...',
    selectBookings: 'Seleccionar reservas',
    selected: 'seleccionado(s)',
    selectAll: 'Seleccionar todo',
    bookings: 'Reservas',
    bookingsFound: 'reserva(s) encontrada(s)',
    noBookingsFound: 'No se encontraron reservas',
    noBookingsAvailable: 'No hay reservas disponibles',
    useFiltersAboveToFindBookings: 'Use los filtros de arriba para encontrar reservas',
    invoiceNotesPlaceholder: 'Notas adicionales para la factura...',
    selectedBookings: 'Reservas seleccionadas',
    vatAmount: 'Monto IVA',
    totalWithTax: 'Total con impuestos',
    creating: 'Creando...',
    createInvoice: 'Crear factura',
    selectCustomer: 'Seleccionar cliente',
    selectService: 'Seleccionar servicio',
    dateType: 'Tipo de fecha',
    loadingBookings: 'Cargando reservas',
    errorLoadingCustomers: 'Error al cargar clientes',
    errorLoadingServices: 'Error al cargar servicios',
    errorLoadingBookings: 'Error al cargar reservas',
    errorCreatingInvoice: 'Error al crear la factura',
    pleaseFillAllFilters: 'Por favor complete todos los filtros',
    selectAtLeastOneBooking: 'Seleccione al menos una reserva',
    invoiceNumberRequired: 'El número de factura es requerido',
    invoiceCreatedSuccess: '¡Factura creada exitosamente!',
    invoiceDetails: 'Detalles de la factura',

        allCustomers: 'Todos los clientes',
    invoiceCreated: '¡Factura creada!',
    configureSearchFilters: 'Configurar filtros de búsqueda',
    customersFound: 'cliente(s) encontrado(s)',
    searchError: 'Error en la búsqueda',
    pleaseSelectDates: 'Por favor seleccione fechas',
    confirmInvoiceCreation: 'Confirmar creación de factura',
    summary: 'Resumen',
    dueDate: 'Fecha de vencimiento',
    invoiceCreationConfirmation: 'La factura se creará con las reservas seleccionadas.',
    selectDueDate: 'Por favor seleccione una fecha de vencimiento',
    confirm: 'Confirmar',

        customerInvoices: 'Facturas Clientes',
    providerInvoices: 'Facturas Proveedores',
    noCustomerInvoices: 'No se encontraron facturas de cliente',
    noProviderInvoices: 'No se encontraron facturas de proveedor',
    useFiltersOrAddInvoice: 'Use filtros o agregue una factura',
    useFiltersToFindInvoices: 'Use filtros para encontrar facturas',
    exportInProgress: 'Exportación en curso...',
    errorLoadingCustomerInvoices: 'Error al cargar facturas de cliente',
    errorLoadingProviderInvoices: 'Error al cargar facturas de proveedor',
    period: 'Período',
    pendingAmount: 'Monto pendiente',
    needAttention: 'Necesita atención',
    totalByCurrency: "Total por Moneda",

      backToInvoices: 'Volver a facturas',
    providerInvoice: 'Factura proveedor',
    customerInvoice: 'Factura cliente',
    invoiceDetail: 'Detalle de la factura',
    paidDate: 'Fecha de pago',
    invoiceID: 'ID de la factura',
    financialDetails: 'Detalles financieros',
    invoicePaid: 'Factura pagada',
    invoiceUnpaid: 'Factura impagada',
    invoiceOverdue: 'Factura vencida',
    paidOn: 'Pagado el',
    dueOn: 'Vence el',
    overdueSince: 'Vencida desde',
    share: 'Compartir',
    duplicate: 'Duplicar',
    exportBookings: 'Exportar reservas',
    invoiceDate: 'Fecha de la factura',
    invoiceDates: 'Fechas de la factura',

        exportBookingsSelection: 'Selección de reservas para exportación',
    search: 'Buscar',
    searchBookingsPlaceholder: 'Buscar por número, titular o servicio...',
    section: 'Sección',
    zipCode: 'Código postal',
    serviceName: 'Nombre del servicio',
    rateId: 'ID de tarifa',
    bookingId: 'ID de reserva',
    invoiceInfo: 'Información de factura',
    selected: 'Seleccionado(s)',
    deselectAll: 'Deseleccionar todo',
    exportSelected: 'Exportar selección',
    noBookingsSelected: 'No hay reservas seleccionadas',

    invoiceInformation: 'Información de factura',
    company: 'Empresa',

        invoice: 'Factura',
    summary: 'Resumen',
    pending: 'Pendiente',
    serviceType: 'Tipo',
    checkinDate: 'Fecha de llegada',
    checkoutDate: 'Fecha de salida',
    totalBookings: 'Total reservas',
    exportGeneratedOn: 'Exportación generada el',
    document: 'Documento',
    exportType: 'Tipo de exportación',
    exportPdfSuccess: 'PDF exportado exitosamente',
    exportPdfError: 'Error al exportar PDF',

    exportToPDF: 'Exportar a PDF',

        // Months
        jan: 'Ene',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Abr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dic',

        // Days
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo',

        // Time expressions
        minutesAgo: 'Hace {{count}} min',
        hoursAgo: 'Hace {{count}}h',
        daysAgo: 'Hace {{count}} día(s)',

        //pays 
        france: 'Francia',
        spain: 'España',
        germany: 'Alemania',
        italy: 'Italia'
    }
};

const useTranslation = (lang) => {
    const t = useCallback((key, variables = {}) => {
        let translation = translations[lang]?.[key] || key;

        // Remplace les variables {{variable}} dans la traduction
        Object.keys(variables).forEach(variable => {
            translation = translation.replace(`{{${variable}}}`, variables[variable]);
        });

        return translation;
    }, [lang]);

    return { t };
};

export { useTranslation };